<template>
    <div class="fullPage">
        <img src="../../assets/image/banner/banner4.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--提单查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('booking.blSearch')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--船名-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t('booking.vesselCode') }}</span>
                                <el-input v-model="search.vesselCode"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable
                                          @input="formatUpper('search','vesselCode',search.vesselCode)"/>
                            </div>
                            <!--航次-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t('booking.voyage') }}</span>
                                <div class="flex flex-space-between">
                                    <el-input v-model="search.voyage" :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','voyage',search.voyage)"/>
                                    <!--VVL弹框-->
                                    <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                                @hide="boatListShow=false">
                                        <div>
                                            <div class="flex flex-space-between">
                                                <!--船名查询条件-->
                                                <div class="inputName-left boatBox">
                                                    <div class="inputName-title-left">
                                                        <span>{{ $t('booking.popover.vessel') }}</span>
                                                    </div>
                                                    <el-input v-model="search.vesselCode"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpper('search','vesselCode',search.vesselCode)"
                                                              @focus="showVesselList">
                                                        <img src="../../assets/image/icon/classification.svg"
                                                             slot="suffix" @click="showVesselList">
                                                    </el-input>
                                                    <!--船名数据列表-->
                                                    <div class="boatBox-list-box" v-show="boatListShow">
                                                        <div class="boatBox-top flex">
                                                            <div class="left">{{ $t('booking.popover.vesselCode') }}</div>
                                                            <div class="right">{{ $t('booking.popover.vesselNameCn') }}
                                                            </div>
                                                        </div>
                                                        <ul>
                                                            <li v-for="(i,j) in boatList" :key="j" class="flex"
                                                                @click="checkBoatData(i)">
                                                                <div class="left">{{ i.vesselCode }}</div>
                                                                <div class="right">{{ i.vesselNameCn }}</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <!--船中文名查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{ $t('booking.popover.vesselNameCn') }}</span>
                                                    </div>
                                                    <el-input v-model="search.vesselName"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpper('search','vesselName',search.vesselName)"/>
                                                </div>
                                                <!--VVL弹框查询按钮-->
                                                <el-button class="popoverInner" @click="vvlSearch" size="small"
                                                           icon="el-icon-search">{{ findButton }}
                                                </el-button>
                                            </div>
                                            <div class="flex flex-space-between">
                                                <!--航次查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{ $t('booking.popover.voyageNo') }}</span>
                                                    </div>
                                                    <el-input v-model="search.voyageNo"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpper('search','voyageNo',search.voyageNo)"/>
                                                </div>
                                                <!--航段查询条件-->
                                                <div class="inputName-left">
                                                    <div class="inputName-title-left">
                                                        <span>{{ $t('booking.popover.voyageLeg') }}</span>
                                                        <span style="visibility:hidden">占位</span>
                                                    </div>
                                                    <el-input v-model="search.voyageLeg"
                                                              :placeholder="$t('common.pleaseEnter')"
                                                              clearable
                                                              @input="formatUpper('search','voyageLeg',search.voyageLeg)"/>
                                                </div>
                                                <!--VVL弹框关闭按钮-->
                                                <el-button size="small" @click="closePopoverView" class="popoverInner"
                                                           icon="el-icon-warning-outline">{{ closeButton }}
                                                </el-button>
                                            </div>
                                            <!--船名航次数据表格-->
                                            <el-table :data="popData" style="width:100%;margin-top:5px"
                                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                      max-height="300" highlight-current-row
                                                      :empty-text="$t('common.noData')"
                                                      @row-dblclick="popRowDblclick" @row-click="popRowClick">
                                                <!--序号-->
                                                <el-table-column min-width="60" type="index"
                                                                 :label="$t('booking.popover.no')"
                                                                 align="center"></el-table-column>
                                                <!--船舶代码-->
                                                <el-table-column min-width="110" prop="vesselCode"
                                                                 :label="$t('booking.popover.vesselCode')"
                                                                 align="center"></el-table-column>
                                                <!--船名-->
                                                <el-table-column min-width="190" prop="vesselName"
                                                                 :label="$t('booking.popover.vessel')"
                                                                 align="center">
                                                </el-table-column>
                                                <!--船中文名-->
                                                <el-table-column min-width="140" prop="vesselNameCn"
                                                                 :label="$t('booking.popover.vesselNameCN')"
                                                                 align="center"></el-table-column>
                                                <!--航次-->
                                                <el-table-column min-width="100" prop="voyageNo"
                                                                 :label="$t('booking.popover.voyageNo')"
                                                                 align="center"></el-table-column>
                                                <!--航段-->
                                                <el-table-column min-width="110" prop="voyageLeg"
                                                                 :label="$t('booking.popover.voyageLeg')"
                                                                 align="center"></el-table-column>
                                            </el-table>
                                            <!--船名航次数据表格pagination分页条-->
                                            <div class="flex flex-space-between">
                                                <div class="topMargin flex1">{{ `共${popTotal}条` }}</div>
                                                <el-button class="topMargin" @click="popConfirm" type="primary">
                                                    {{ confirmButton }}
                                                </el-button>
                                                <div class="pagination flex1">
                                                    <el-pagination small layout="sizes,pager" :page-size="popPageSize"
                                                                   :page-sizes="[5, 10]" :total="popTotal"
                                                                   :pager-count="popPageCount"
                                                                   :current-page="popPageNum"
                                                                   @size-change="popHandleSizeChange"
                                                                   @current-change="popHandleCurrentChange"
                                                                   max-height="600"></el-pagination>
                                                </div>
                                            </div>
                                        </div>
                                        <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                             src="../../assets/image/voyage.png"/>
                                    </el-popover>
                                </div>
                            </div>
                            <!--装货港-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.loadingPort") }}</span>
                                <el-select v-model="search.loadingPort"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable filterable default-first-option
                                           @focus="portFocus">
                                    <el-option v-for="item in portOptions" :key="item.portCode"
                                               :label="item.portCode" :value="item.portCode">
                                        <span style="float: left">{{ item.portCode }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.portNameCn }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--卸货港-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.dischargePort") }}</span>
                                <el-select v-model="search.dischargePort"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable filterable default-first-option
                                           @focus="portFocus">
                                    <el-option v-for="item in portOptions" :key="item.portCode"
                                               :label="item.portCode" :value="item.portCode">
                                        <span style="float: left">{{ item.portCode }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.portNameCn }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--开航时间从-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.sailingTimeStart") }}</span>
                                <el-date-picker v-model="search.sailingTimeStart" type="date"
                                                :placeholder="$t('common.pleaseSelectDate')"
                                                class="dateInput"></el-date-picker>
                            </div>
                            <!--开航时间到-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.sailingTimeEnd") }}</span>
                                <el-date-picker v-model="search.sailingTimeEnd" type="date"
                                                :placeholder="$t('common.pleaseSelectDate')"
                                                class="dateInput"></el-date-picker>
                            </div>
                            <!--创建时间从-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.crateTimeStart") }}</span>
                                <el-date-picker v-model="search.crateTimeStart" type="date"
                                                :placeholder="$t('common.pleaseSelectDate')"
                                                class="dateInput"></el-date-picker>
                            </div>
                            <!--创建时间到-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.crateTimeEnd") }}</span>
                                <el-date-picker v-model="search.crateTimeEnd" type="date"
                                                :placeholder="$t('common.pleaseSelectDate')"
                                                class="dateInput"></el-date-picker>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--订舱号-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.bkNo") }}</span>
                                <el-input v-model="search.bookingNo" :placeholder="$t('common.pleaseEnter')"
                                          clearable
                                          @input="formatUpper('search','bookingNo',search.bookingNo)"/>
                            </div>
                            <!--提单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.blNo") }}</span>
                                <el-input v-model="search.billNo" :placeholder="$t('common.pleaseEnter')"
                                          clearable
                                          @input="formatUpper('search','billNo',search.billNo)"/>
                            </div>
                            <!--提单状态-->
                            <div class="inputName">
                                <span class="inputName-title">{{ $t("booking.blStatus") }}</span>
                                <el-select v-model="search.blStatus"
                                           :placeholder="$t('common.pleaseSelect')" clearable>
                                    <el-option v-for="item in blStatusOptions" :key="item.codeValue"
                                               :label="getDisplayValue(item)"
                                               :value="item.codeValue">
                                        <span style="float: left">{{ item.displayValue }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValueCn }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="searchBtn">
                                <!--查询按钮-->
                                <el-button @click="searchBtnClick" type="primary" icon="el-icon-search">
                                    {{ searchButton }}
                                </el-button>
                                <!--重置按钮-->
                                <el-button icon="el-icon-refresh" @click="resetBtnClick">{{ resetButton }}</el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <result-bar>
                <div slot="resultRight">
                    <!--全选-->
                    <el-button icon="el-icon-my-selectAll" @click="checkAllBtnClick(true)">
                        {{ $t("common.selectAll") }}
                    </el-button>

                    <!--反选-->
                    <el-button icon="el-icon-my-selectInverse" @click="checkAllBtnClick(false)">
                        {{ $t("common.selectInverse") }}
                    </el-button>

                    <!--提单EDI报文导入-->
                    <el-button @click="BookingEdiImportBtn()">
                        {{ $t('booking.billEDIMessageImport') }}
                    </el-button>

                    <!--提单EDI报文说明下载-->
                    <el-button icon="el-icon-download" @click="BookingEdiInstructBtn()">
                        {{ $t('booking.billEDIMessageInstructDownLoad') }}
                    </el-button>

                    <!-- 批量操作下拉菜单 -->
                    <el-dropdown @command="handleBatchOperation" style="margin-left: 10px;">
                      <el-button>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                        {{ batchButton }}
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <!--批量提交SI信息-->
                        <el-dropdown-item command="submitSi">
                          <i class="el-icon-s-promotion"></i>
                          {{ $t('booking.sumitSiInformation') }}
                        </el-dropdown-item>

                        <!--批量下载预览格式件-->
                        <el-dropdown-item command="batchPreview">
                          <i class="el-icon-download"></i>
                          {{ BatchDownloadPreviewFormatting }}
                        </el-dropdown-item>

                        <!--提单批量下载-->
                        <el-dropdown-item command="batchDownload">
                          <i class="el-icon-download"></i>
                          {{ blBatchDownload }}
                        </el-dropdown-item>

                        <!-- 批量VGM上传（改为普通 dropdown-item） -->
                        <el-dropdown-item command="batchVgmUpload">
                          <i class="el-icon-upload"></i>
                          {{ batchUploadVgmButton }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <!--表格/卡片视图切换-->
                    <vxe-switch v-model="showViewFlag" style="margin-left: 5px"
                                open-label="common.cardView" close-label="common.tableView"
                                open-icon="el-icon-notebook-2" close-icon="vxe-icon-table"
                                open-value="card" close-value="table" @change="handleViewStyle">
                    </vxe-switch>
                </div>
            </result-bar>
            <!--无数据组件-->
            <div v-if="showNoDataView || tableData.length === 0" class="noData">
                <no-data-view/>
            </div>
            <!--查询结果-->
            <div class="contentListCom" v-else>

                <!--展开视图-->
                <div class="oneContent" v-for="(data,index) in tableData" :key="index" v-if="showViewFlag==='card'">
                    <template>
                        <div class="top overflow">
                            <template>
                                <template>
                                    <!--多选控件-->
                                    <el-checkbox class="checkOne l" v-model="data.checked" :key="index"
                                                 @change="checkOneMethod(index,data.checked)"></el-checkbox>
                                    <!--船名-->
                                    <p class="listContentLong l">
                                        <span class="firstSpan">{{ $t('booking.vesselName') }}：</span>
                                        <span class="secondSpan blueColor">{{ data.vesselName }}</span>
                                    </p>
                                    <!--航次-->
                                    <p class="listContentShort l">
                                        <span class="firstSpan">{{ $t('booking.voyage') }}：</span>
                                        <span class="secondSpan">{{ data.voyageNo }}/{{ data.voyageLeg }}</span>
                                    </p>
                                    <!--装货港-->
                                    <p class="listContent l">
                                        <span class="firstSpan">{{ $t('booking.pol') }}：</span>
                                        <span class="secondSpan blueColor">{{ getPolDisplayValue(data) }}</span>
                                    </p>
                                    <!--卸货港-->
                                    <p class="listContent l">
                                        <span class="firstSpan">{{ $t('booking.pod') }}：</span>
                                        <span class="secondSpan blueColor">{{ getPodDisplayValue(data) }}</span>
                                    </p>
                                    <!--目的港-->
                                    <p class="listContent l">
                                        <span class="firstSpan">{{ $t('booking.del') }}：</span>
                                        <span class="secondSpan blueColor">{{ getDelDisplayValue(data) }}</span>
                                    </p>
                                </template>
                                <!--编辑按钮-->
                                <el-button class="normalListButton r red-button feeDetail" size="small"
                                           @click="editBtnClick(data)">{{ editButton }}
                                </el-button>
                            </template>
                        </div>
                        <div class="center flexDiv">
                            <!--提单状态图标-->
                            <!--确认-->
                            <div class="typeImg blConfirmImg" v-show="getCurLanguage() != 'en' && data.blStatus == 1"/>
                            <div class="typeImg blConfirmEnImg"
                                 v-show="getCurLanguage() == 'en' && data.blStatus == 1"/>
                            <!--拒绝-->
                            <div class="typeImg blRefuseImg" v-show="getCurLanguage() != 'en' && data.blStatus == 2"/>
                            <div class="typeImg blRefuseEnImg" v-show="getCurLanguage() == 'en' && data.blStatus == 2"/>
                            <!--等待-->
                            <div class="typeImg blWaitImg" v-show="getCurLanguage() != 'en' && data.blStatus == 0"/>
                            <div class="typeImg blWaitEnImg" v-show="getCurLanguage() == 'en' && data.blStatus == 0"/>
                            <!--草稿-->
                            <div class="typeImg blDraftImg" v-show="getCurLanguage() != 'en' && data.blStatus == 4"/>
                            <div class="typeImg blDraftEnImg" v-show="getCurLanguage() == 'en' && data.blStatus == 4"/>
                            <el-descriptions style="margin-right: 150px" size="medium" :column=4>
                                <!--订舱号-->
                                <el-descriptions-item :label="$t('booking.bkNo')">{{ data.bkNo }}</el-descriptions-item>
                                <!--提单号-->
                                <el-descriptions-item :label="$t('booking.blNo')">{{ data.blNo }}</el-descriptions-item>
                                <!--运输条款-->
                                <el-descriptions-item :label="$t('bookingSpace.booking.transportationTerms')">
                                    <el-tag size="small">{{ data.transportationTerms }}</el-tag>
                                </el-descriptions-item>
                                <!--付费方式-->
                                <el-descriptions-item :label="$t('bookingSpace.booking.paidType')">
                                    <el-tag class="blue_tag" size="small">{{ data.paidType == 0 ? 'PP' : 'CC' }}</el-tag>
                                </el-descriptions-item>
                                <el-descriptions-item :label="$t('bookingSpace.bl.releaseStatus')">{{ getReleaseStatusDisplayValue(data) }}</el-descriptions-item>
                                <!--放货状态-->
                                <el-descriptions-item :label="$t('bookingSpace.bl.blReleaseFlag')">{{ getBlReleaseFlagDisplayValue(data) }}</el-descriptions-item>
                                <!--单证类型-->
                                <el-descriptions-item :label="$t('bookingSpace.bl.deliveryDocumentMethod')">{{ getdeliveryMethodDisplayValue(data) }}</el-descriptions-item>
                                <!--开航时间-->
                                <el-descriptions-item :label="$t('bookingSpace.main.saillingDate')">{{ data.saillingDate }}</el-descriptions-item>
                                <!--保函提交状态-->
                                <el-descriptions-item :label="$t('booking.guaranteeSubmissionStatus')">{{ getGuaranteeSubmissionStatusValue(data) }}</el-descriptions-item>
                                <!--保函审核状态-->
                                <el-descriptions-item :label="$t('booking.guaranteeReviewStatus')">{{ getGuaranteeReviewStatusValue(data) }}</el-descriptions-item>
                                <!--SI备注-->
                                <el-descriptions-item :label="$t('bookingSpace.other.siRemark')">{{ data.siRemark }}</el-descriptions-item>
                                <!--提单拒绝-->
                                <el-descriptions-item :label="$t('bookingSpace.other.blReject')">{{
                                    data.blStatus == 2 ? data.bkExtends[0].siRejectReason : ""
                                    }}
                                </el-descriptions-item>
                                <!--箱型箱量-->
                                <el-descriptions-item :label="$t('booking.containerTypeAndQuantity')">{{ getContainerTypeAndQuantity(data) }}</el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                    <div class="bottom overflow">
                        <!--修改时间-->
                        <div class="l flexDiv leftMessage">
                            <p class="documentValid fontWeight msg">{{ $t('booking.updatedDtmLoc') }}：{{
                                data.updatedDtmLoc
                                }}</p>
                        </div>
                        <div class="r flexDiv">
                            <template>
                                <div class="upload-container" style="margin-right: 15px;">
                                    <!-- 下拉菜单 -->
                                    <el-dropdown placement="bottom-start">
                                        <el-button type="success" size="small" style="margin-top: 4px; height: 32px;" icon="el-icon-s-grid">
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                             {{ uploadVgmButton }}
                                        </el-button>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <!-- 上传按钮 -->
                                                <el-dropdown-item style="height:30px">
                                                    <el-upload
                                                            ref="vgmUpload"
                                                            action=""
                                                            :file-list="vgmFileList"
                                                            :show-file-list="false"
                                                            accept=".xls,.xlsx"
                                                            :auto-upload="true"
                                                            :http-request="file => handleVgmUpload(file, data)"
                                                            :on-error="handleVgmUploadError">
                                                        <el-button type="text" style="font-size: 12px;margin-right: 10px" icon="el-icon-upload2">EXCEL上传</el-button>
                                                    </el-upload>
                                                </el-dropdown-item>
                                                <!-- 查看数据按钮 -->
                                                <el-dropdown-item divided style="height:30px">
                                                    <el-button type="text" style="font-size: 12px;margin-right: 10px" icon="el-icon-reading" @click="viewVgmBtnClick(data)">VGM
                                                        查看
                                                    </el-button>
                                                </el-dropdown-item>
                                                <!-- VGM导入模板下载 -->
                                                <el-dropdown-item divided style="height:30px">
                                                    <el-link type="primary" style="font-size: 12px;margin-right: 10px" icon="el-icon-download" :underline="false"
                                                             href="/static/vgmImportTemplate.xlsx" download="VGM_IMPORT_TEMPLATE.xlsx">EXCEL上传模板下载
                                                    </el-link>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </div>

                                <!--预览按钮-->
                                <el-button size="small" style="margin-top: 4px; height: 32px;" class="normalListBlueButton" icon="el-icon-s-order"
                                           @click="previewBtnClick(data)">
                                    {{ preViewButton }}
                                </el-button>

                                <!--提单下载按钮  提单状态：确认|保函审核状态：审核通过 |放单状态：放单 |放货状态：放货 时允许下载提单-->
                                <el-button size="small" style="margin-top: 4px; height: 32px;" class="normalListButton" type="primary" icon="el-icon-download"
                                           @click="blDownloadBtnClick(data)"
                                           :disabled="(data.deliveryDocumentMethod != 2 && data.deliveryDocumentMethod != 3)
                                                            || (data.blStatus !=1)
                                                            || (data.releaseStatus != 1
                                                                && data.releaseStatus != 2
                                                                && data.releaseStatus != 3)
                                                            || (data.blReleaseFlag != 0)
                                                            || (data.bkExtends != null && data.bkExtends[0] != null
                                                                && (data.bkExtends[0].guaranteeReviewStatus != 2))">{{ blDownload }}
                                </el-button>

                                <!--上传保函按钮-->
                                <el-button size="small" style="margin-top: 4px; height: 32px;" class="normalListButton" type="warning" icon="el-icon-upload"
                                           @click="guaranteeUploadBtnClick(data)"
                                           :disabled="data.bkContainers == null || data.bkContainers.length <= 0">{{ guaranteeUpload }}
                                </el-button>
                                <!--查看历史按钮-->
                                <el-button size="small" style="margin-top: 4px; height: 32px;" class="normalListButton" type="info" icon="el-icon-view"
                                           @click="viewHistoryBtnClick(data)">
                                    {{ historyButton }}
                                </el-button>
                            </template>
                        </div>
                    </div>
                </div>
                <!--订舱数据表格pagination分页条-->
                <div class="pagination" v-if="showViewFlag==='card'">
                    <div>
                        <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                       max-height="600"
                                       :page-size="pageSize" :pager-count="pageCount"
                                       :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                                       :current-page="pageNum"
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"/>
                    </div>
                </div>

                <!--表格视图-->
                <div class="mainTable" v-if="showViewFlag==='table'">
                    <vxe-grid show-overflow
                              ref="tableData" class="vxeTable"
                              height="500" size="small"
                              :row-config="{isCurrent: true, isHover: true}"
                              :column-config="{resizable: true}"
                              :export-config="{}"
                              :checkbox-config="{checkStrictly: true}"
                              @checkbox-change="handleTableDataChecked"
                              resizable
                              keep-source
                              show-footer
                              :data="tableData"
                              :columns="tableColumn"
                              :toolbar-config="tableToolbar">
                        <!--顶部工具栏插槽-->
                        <template #toolbar_buttons>
                            <vxe-button @click="exportDataEvent" status="primary" type="text" icon="vxe-icon-file-excel" style="margin-left: 10px">
                                {{ exportDataButton }}
                            </vxe-button>
                            <vxe-button @click="$refs.tableData.hideColumn($refs.tableData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill-close"
                                        style="margin-left: 10px">
                                {{ $t('common.menuHide') }}
                            </vxe-button>
                            <vxe-button @click="$refs.tableData.showColumn($refs.tableData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill"
                                        style="margin-left: 10px">
                                {{ $t('common.menuShow') }}
                            </vxe-button>
                        </template>
                        <!--提单状态插槽-->
                        <template #column_blStatus="{ row }">
                            <!--确认-->
                            <span class="blueColor" v-if="row.blStatus == 1">{{ getBlStatusDisplayValue(row) }}</span>
                            <!--拒绝-->
                            <span class="redColor" v-else-if="row.blStatus == 2">{{ getBlStatusDisplayValue(row) }}</span>
                            <!--等待-->
                            <span class="yellowColor" v-else-if="row.blStatus == 0">{{ getBlStatusDisplayValue(row) }}</span>
                            <!--草稿-->
                            <span class="greenColor" v-else-if="row.blStatus == 4">{{ getBlStatusDisplayValue(row) }}</span>
                            <!--默认-->
                            <span v-else>{{ getBlStatusDisplayValue(row) }}</span>
                        </template>
                        <!--船名插槽-->
                        <template #column_vesselName="{ row }">
                            <span class="blueColor">{{ row.vesselName }}</span>
                        </template>
                        <!--提单号插槽-->
                        <template #column_blNo="{ row }">
                            <span style="font-weight: bold">{{ row.blNo }}</span>
                        </template>
                        <!--装货港插槽-->
                        <template #column_polName="{ row }">
                            <span class="blueColor">{{ getPolDisplayValue(row) }}</span>
                        </template>
                        <!--卸货港插槽-->
                        <template #column_podName="{ row }">
                            <span class="blueColor">{{ getPodDisplayValue(row) }}</span>
                        </template>
                        <!--目的港插槽-->
                        <template #column_delName="{ row }">
                            <span class="blueColor">{{ getDelDisplayValue(row) }}</span>
                        </template>
                        <!--运输条款插槽-->
                        <template #column_transportationTerms="{ row }">
                            <el-tag size="small">{{ row.transportationTerms }}</el-tag>
                        </template>
                        <!--付费方式插槽-->
                        <template #column_paidType="{ row }">
                            <el-tag class="blue_tag" size="small">{{ row.paidType == 0 ? 'PP' : 'CC' }}</el-tag>
                        </template>
                        <!--提单类型插槽-->
                        <template #column_deliveryDocumentMethod="{ row }">
                            <span>{{ getdeliveryMethodDisplayValue(row) }}</span>
                        </template>
                        <!--放单状态插槽-->
                        <template #column_releaseStatus="{ row }">
                            <span>{{ getReleaseStatusDisplayValue(row) }}</span>
                        </template>
                        <!--放货状态插槽-->
                        <template #column_blReleaseFlag="{ row }">
                            <span>{{ getBlReleaseFlagDisplayValue(row) }}</span>
                        </template>
                        <!--保函提交状态插槽-->
                        <template #column_guaranteeSubmissionStatus="{ row }">
                            <span>{{ getGuaranteeSubmissionStatusValue(row) }}</span>
                        </template>
                        <!--保函审核状态插槽-->
                        <template #column_guaranteeReviewStatus="{ row }">
                            <span>{{ getGuaranteeReviewStatusValue(row) }}</span>
                        </template>
                        <!--操作按钮插槽-->
                        <template #operate_default="{ row }">
                            <div class="vxe-operate-default">
                                <!--明细按钮-->
                                <el-tooltip class="item" effect="dark" :content="viewDetails" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" type="primary" icon="el-icon-edit" circle @click="editBtnClick(row)"></el-button>
                                </el-tooltip>

                                <!--预览按钮-->
                                <el-tooltip class="item" effect="dark" :content="preViewButton" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" class="blue-button" icon="el-icon-document" circle @click="previewBtnClick(row)"></el-button>
                                </el-tooltip>

                                <!--提单下载按钮-->
                                <el-button size="mini" style="margin-top: 2px" type="text" class="greenColor" icon="el-icon-download"
                                           @click="blDownloadBtnClick(row)"
                                           :disabled="(row.deliveryDocumentMethod != 2 && row.deliveryDocumentMethod != 3)
                                                            || (row.releaseStatus != 2
                                                                && row.releaseStatus != 3)
                                                            || (row.blReleaseFlag != 0)
                                                            || (row.bkExtends != null && row.bkExtends[0] != null
                                                                && (row.bkExtends[0].guaranteeReviewStatus != 2))">{{ blDownload }}
                                </el-button>

                                <!--保函上传按钮-->
                                <el-button size="mini" style="margin-top: 2px" class="yellowColor" type="text" icon="el-icon-upload"
                                           @click="guaranteeUploadBtnClick(row)"
                                           :disabled="row.bkContainers == null || row.bkContainers.length <= 0">{{ guaranteeUpload }}
                                </el-button>
                            </div>
                        </template>
                        <template #pager>
                            <vxe-pager
                                    :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                    :current-page.sync="pageNum"
                                    :page-size.sync="pageSize"
                                    :page-sizes="[10, 20, 50, 100, 200]"
                                    :total="total"
                                    @page-change="handleTablePageChange">
                            </vxe-pager>
                        </template>
                    </vxe-grid>
                </div>
            </div>
        </div>

        <!--订舱信息弹出框-->
        <el-dialog :visible.sync="dialogVisible" width="90%" top="3%" class="bkSelectDialog">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/add.svg">
                {{ $t("common.newButton") }}
            </div>
            <div class="flex flex-space-around">
                <!--订舱信息弹出框-船名-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.vesselCode") }}</span>
                    <el-input v-model="bkSearch.vesselCode"
                              :placeholder="$t('common.pleaseEnter')"
                              clearable
                              @input="formatUpper('bkSearch','vesselCode',bkSearch.vesselCode)"/>
                </div>
                <!--订舱信息弹出框-航次-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t('booking.voyage') }}</span>
                    <div class="flex flex-space-between">
                        <el-input v-model="bkSearch.voyage"
                                  :placeholder="$t('common.pleaseEnter')"
                                  clearable
                                  @input="formatUpper('bkSearch','voyage',bkSearch.voyage)"/>
                        <!--订舱信息弹出框-VVL弹框-->
                        <el-popover ref="popover" placement="bottom" width="650" trigger="click"
                                    @hide="boatListShow=false">
                            <div class="popoverView">
                                <div class="flex flex-space-between">
                                    <div class="inputName-left boatBox">
                                        <div class="inputName-title-left">
                                            <span>{{ $t('booking.popover.vessel') }}</span>
                                        </div>
                                        <el-input v-model="bkSearch.vesselCode" :placeholder="$t('common.pleaseEnter')"
                                                  clearable
                                                  @input="formatUpper('bkSearch','vesselCode',bkSearch.vesselCode)"
                                                  @focus="showVesselList">
                                            <img src="../../assets/image/icon/classification.svg" slot="suffix"
                                                 @click="showVesselList">
                                        </el-input>
                                        <div class="boatBox-list-box" v-show="boatListShow">
                                            <div class="boatBox-top flex">
                                                <div class="left">{{ $t('booking.popover.vesselCode') }}</div>
                                                <div class="right">{{ $t('booking.popover.vesselNameCn') }}
                                                </div>
                                            </div>
                                            <ul>
                                                <li v-for="(i,j) in boatList" :key="j" class="flex"
                                                    @click="bkCheckBoatData(i)">
                                                    <div class="left">{{ i.vesselCode }}</div>
                                                    <div class="right">{{ i.vesselNameCn }}</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{ $t('booking.popover.vesselNameCn') }}</span>
                                        </div>
                                        <el-input v-model="bkSearch.vesselName" :placeholder="$t('common.pleaseEnter')"
                                                  clearable
                                                  @input="formatUpper('bkSearch','vesselName',bkSearch.vesselName)"/>
                                    </div>
                                    <el-button class="popoverInner" size="small" @click="bkVvlSearch"
                                               icon="el-icon-search">{{ findButton }}
                                    </el-button>
                                </div>
                                <div class="flex flex-space-between">
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{ $t('booking.popover.voyageNo') }}</span>
                                        </div>
                                        <el-input v-model="bkSearch.voyageNo"
                                                  :placeholder="$t('common.pleaseEnter')"
                                                  clearable
                                                  @input="formatUpper('bkSearch','voyageNo',bkSearch.voyageNo)"/>
                                    </div>
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{ $t('booking.popover.voyageLeg') }}</span>
                                            <span style="visibility:hidden">占位</span>
                                        </div>
                                        <el-input v-model="bkSearch.voyageLeg"
                                                  :placeholder="$t('common.pleaseEnter')"
                                                  clearable
                                                  @input="formatUpper('bkSearch','voyageLeg',bkSearch.voyageLeg)"/>
                                    </div>
                                    <el-button size="small" @click="closePopoverView" class="popoverInner"
                                               icon="el-icon-warning-outline">{{ closeButton }}
                                    </el-button>
                                </div>
                                <el-table :data="popData" style="width:100%;margin-top:5px"
                                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                          :row-style="{height:'35px'}" :cell-style="{padding:'0px'}" max-height="300"
                                          :empty-text="$t('common.noData')"
                                          highlight-current-row @row-dblclick="bkRowDblclick"
                                          @row-click="popRowClick">
                                    <el-table-column min-width="60" type="index" :label="$t('booking.popover.no')"
                                                     align="center"></el-table-column>
                                    <el-table-column min-width="110" prop="vesselCode"
                                                     :label="$t('booking.popover.vesselCode')"
                                                     align="center"></el-table-column>
                                    <el-table-column min-width="190" prop="vesselName"
                                                     :label="$t('booking.popover.vessel')"
                                                     align="center"></el-table-column>
                                    <el-table-column min-width="140" prop="vesselNameCn"
                                                     :label="$t('booking.popover.vesselNameCN')"
                                                     align="center"></el-table-column>
                                    <el-table-column min-width="100" prop="voyageNo"
                                                     :label="$t('booking.popover.voyageNo')"
                                                     align="center"></el-table-column>
                                    <el-table-column min-width="110" prop="voyageLeg"
                                                     :label="$t('booking.popover.voyageLeg')"
                                                     align="center"></el-table-column>
                                </el-table>
                                <div class="flex flex-space-between">
                                    <div class="topMargin flex1">{{ `共${popTotal}条` }}</div>
                                    <el-button class="topMargin" @click="bkPopConfirm" type="primary">
                                        {{ confirmButton }}
                                    </el-button>
                                    <div class="pagination flex1">
                                        <el-pagination small layout="sizes,pager" :page-size="popPageSize"
                                                       :page-sizes="[5, 10]" :total="popTotal"
                                                       :pager-count="popPageCount" :current-page="popPageNum"
                                                       @size-change="bkPopHandleSizeChange"
                                                       @current-change="bkPopHandleCurrentChange"
                                                       max-height="600"></el-pagination>
                                    </div>
                                </div>
                            </div>
                            <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                 src="../../assets/image/voyage.png"/>
                        </el-popover>
                    </div>
                </div>
                <!--订舱信息弹出框-装货港-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.loadingPort") }}</span>
                    <el-select v-model="bkSearch.loadingPort"
                               :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option
                               @focus="portFocus">
                        <el-option v-for="item in portOptions" :key="item.portCode" :label="item.portCode"
                                   :value="item.portCode"/>
                    </el-select>
                </div>
                <!--订舱信息弹出框-卸货港-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.dischargePort") }}</span>
                    <el-select v-model="bkSearch.dischargePort"
                               :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option
                               @focus="portFocus">
                        <el-option v-for="item in portOptions" :key="item.portCode" :label="item.portCode"
                                   :value="item.portCode"/>
                    </el-select>
                </div>
            </div>
            <div class="flex flex-space-around topMargin">
                <!--订舱信息弹出框-开航时间从-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.sailingTimeStart") }}</span>
                    <el-date-picker v-model="bkSearch.sailingTimeStart" type="date"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    class="dateInput"></el-date-picker>
                </div>
                <!--订舱信息弹出框-开航时间到-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.sailingTimeEnd") }}</span>
                    <el-date-picker v-model="bkSearch.sailingTimeEnd" type="date"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    class="dateInput"></el-date-picker>
                </div>
                <!--订舱信息弹出框-创建时间从-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.crateTimeStart") }}</span>
                    <el-date-picker v-model="bkSearch.crateTimeStart" type="date"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    class="dateInput"></el-date-picker>
                </div>
                <!--订舱信息弹出框-创建时间到-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.crateTimeEnd") }}</span>
                    <el-date-picker v-model="bkSearch.crateTimeEnd" type="date"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    class="dateInput"></el-date-picker>
                </div>
            </div>
            <div class="flex flex-space-around topMargin">
                <!--订舱信息弹出框-订舱号-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.bkNo") }}</span>
                    <el-input v-model="bkSearch.bookingNo" :placeholder="$t('common.pleaseEnter')" clearable
                              @input="formatUpper('bkSearch','bookingNo',bkSearch.bldownloadbookingNo)"/>
                </div>
                <!--订舱信息弹出框-提单号-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.blNo") }}</span>
                    <el-input v-model="bkSearch.billNo" :placeholder="$t('common.pleaseEnter')" clearable
                              @input="formatUpper('bkSearch','billNo',bkSearch.billNo)"/>
                </div>
                <!--订舱信息弹出框-订舱状态-->
                <div class="inputName">
                    <span class="inputName-title">{{ $t("booking.bookingStatus") }}</span>
                    <el-select v-model="bkSearch.bookingStatus" :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option
                               @focus="bookingStatusFocus">
                        <el-option v-for="item in bookingStatusOptions" :key="item.codeValue"
                                   :label="item.displayValueCn"
                                   :value="item.codeValue">
                            <span style="float: left">{{ item.displayValueCn }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="searchBtn">
                    <!--订舱信息弹出框-查询按钮-->
                    <el-button @click="bkSearchBtnClick" type="primary" icon="el-icon-search">{{ searchButton }}
                    </el-button>
                    <!--订舱信息弹出框-重置按钮-->
                    <el-button @click="bkResetBtnClick" icon="el-icon-refresh">{{ resetButton }}</el-button>
                </div>
            </div>
            <!--订舱信息弹出框-订舱数据表格-->
            <el-table :data="tableDataAdd" style="width:100%;margin-top:15px"
                      :header-cell-style="{background:'#E9E9E9',height:'36px'}" :row-style="{height:'40px'}"
                      :cell-style="{padding:'0px'}" max-height="300" highlight-current-row @row-click="bkRowClick"
                      :empty-text="$t('common.noData')">
                <el-table-column min-width="60" show-overflow-tooltip type="index" :label="$t('booking.no')"
                                 align="center"></el-table-column>
                <el-table-column min-width="90" show-overflow-tooltip prop="bookingStatus"
                                 :label="$t('booking.bookingStatus')" align="center">
                    <template slot-scope="scope">
                        <!--订舱确认/锁定/解锁-->
                        <span v-show="scope.row.bookingStatus == 1 || scope.row.bookingStatus == 4 || scope.row.bookingStatus == 5"
                              class="blueColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                        <!--订舱拒绝-->
                        <span v-show="scope.row.bookingStatus == 8"
                              class="redColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                        <!--订舱等待-->
                        <span v-show="scope.row.bookingStatus == 0"
                              class="yellowColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                        <!--订舱取消-->
                        <span v-show="scope.row.bookingStatus == 3"
                              class="grayColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                        <!--完船确认-->
                        <span v-show="scope.row.bookingStatus == 6"
                              class="blackColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                        <!--草稿-->
                        <span v-show="scope.row.bookingStatus == 9"
                              class="greenColor">{{ getBookingStatusDisplayValue(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="160" show-overflow-tooltip prop="bkNo" :label="$t('booking.bkNo')"
                                 align="center"></el-table-column>
                <el-table-column min-width="160" show-overflow-tooltip prop="blNo" :label="$t('booking.blNo')"
                                 align="center"></el-table-column>
                <el-table-column min-width="160" show-overflow-tooltip prop="vesselName"
                                 :label="$t('booking.vesselName')" align="center">
                    <template slot-scope="scope">
                        <span class="blueColor">{{ scope.row.vesselName }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="80" show-overflow-tooltip prop="voyage" :label="$t('booking.voyage')"
                                 align="center"></el-table-column>
                <el-table-column min-width="120" show-overflow-tooltip prop="polName" :label="$t('booking.pol')"
                                 align="center">
                    <template slot-scope="scope">
                        <span class="blueColor">{{ getPolDisplayValue(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" show-overflow-tooltip prop="polEtd" :label="$t('booking.polEtd')"
                                 align="center"></el-table-column>
                <el-table-column min-width="120" show-overflow-tooltip prop="podName" :label="$t('booking.pod')"
                                 align="center">
                    <template slot-scope="scope">
                        <span class="blueColor">{{ getPodDisplayValue(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" show-overflow-tooltip prop="podEta" :label="$t('booking.podEta')"
                                 align="center"></el-table-column>
                <el-table-column min-width="120" show-overflow-tooltip prop="delName" :label="$t('booking.del')"
                                 align="center">
                    <template slot-scope="scope">
                        <span class="blueColor">{{ getDelDisplayValue(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="160" show-overflow-tooltip prop="updatedDtmLoc"
                                 :label="$t('booking.updatedDtmLoc')"
                                 align="center"></el-table-column>
                <el-table-column min-width="150" show-overflow-tooltip prop="remark" :label="$t('booking.remark')"
                                 align="center">
                    <template slot-scope="scope">
                        <span class="grayColor">{{ scope.row.remark }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <!--订舱信息弹出框-确定按钮-->
                <el-button class="blue-button" @click="bkConfirm">{{ okButton }}</el-button>
                <!--订舱信息弹出框-取消按钮-->
                <el-button @click="dialogVisible = false">{{ cancelButton }}</el-button>
            </span>
        </el-dialog>

        <!--【保函上传】对话框-->
        <el-dialog
                :visible.sync="guaranteeUploadDialogVisible"
                width="50%" top="5%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{ this.currentBookingHead == null ? '' : this.currentBookingHead.blNo + $t("booking.guaranteeUpload") }}</i>
            </div>
            <el-upload
                    class="upload-demo"
                    ref="upload"
                    action=""
                    :limit="fileLimit"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :http-request="handleSubmit"
                    :file-list="fileList"
                    :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary" icon="el-icon-plus"
                >{{ $t("common.selectFiles") }}
                </el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" icon="el-icon-upload2" @click="uploadFiles()"
                           :disabled="getStepActive==2||getStepActive==3">{{ $t("common.uploadFiles") }}
                </el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" icon="el-icon-upload2" @click="submitUpload()"
                           :disabled="!(getStepActive==3)">{{ $t("common.laterUploadFiles") }}
                </el-button>

                <div slot="tip" class="el-upload__tip" style="color:#BC1920;">{{ $t("common.guaranteeUploadTip") }}</div>
            </el-upload>

            <!-- Table -->
            <div class="guaranteeTable" style="margin-top: 20px">
                <div>
                    <el-steps :space="240" :active="getStepActive" finish-status="success" style="margin-top: 20px">
                        <!--step1：SI信息上传-->
                        <el-step :title="this.$t('common.uploadSIInfo')"></el-step>

                        <!--step2：保函未提交/已提交-->
                        <el-step v-if="getSubmissionStatus==null || getSubmissionStatus==0" :title="this.$t('common.guaranteeUnSubmit')"></el-step>
                        <el-step v-else :title="this.$t('common.guaranteeSubmit')"></el-step>

                        <!--step3：保函未审核/审核中/审核不通过/审核通过-->
                        <el-step v-if="getReviewStatus==null || getReviewStatus === ''" :title="this.$t('common.guaranteeUnApproved')"></el-step>
                        <el-step v-else-if="getReviewStatus==0" :title="this.$t('common.guaranteeApproving')"></el-step>
                        <el-step v-else-if="getReviewStatus==1" :title="this.$t('common.guaranteeRejected')"></el-step>
                        <el-step v-else :title="this.$t('common.guaranteeApproved')"></el-step>
                    </el-steps>
                </div>
                <!--保函审核备注-->
                <div v-show="getReviewStatus==1">
                    <p class="listContent longListContent">
                        <span class="firstSpan" style="font-weight: bold">{{ $t("booking.guaranteeReviewedRemarks") }}：</span>
                        <span class="secondSpan">{{ this.currentBookingHead == null ? "" : this.currentBookingHead.bkExtends[0].guaranteeReviewedRemarks }}</span>
                    </p>
                </div>
                <el-table ref="multipleTable" style="width: 100%"
                          :data="tableUpLoadedGuranteeFile"
                          :row-style="{height:'40px'}"
                          tooltip-effect="dark"
                          :empty-text="$t('common.noData')">
                    <el-table-column type="index" width="50"/>
                    <el-table-column prop="enclosurName" :label="this.$t('booking.enclosurName')" width="250"/>
                    <el-table-column prop="createdDtmLoc" :label="this.$t('booking.uploadTime')" width="200"/>
                    <el-table-column :label="this.$t('common.operation')">
                        <template slot-scope="scope">
                            <!--删除-->
                            <el-button size="mini" type="info" @click="handleDelete(scope.$index, scope.row)">{{ $t("common.deleteButton") }}</el-button>
                            <!--查看-->
                            <el-button size="mini" type="primary" @click="openFile(scope.row.enclosurUrl)">{{ $t("common.viewButton") }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </el-dialog>
        <!--【保函上传】对话框-上传文件提示  -->
        <el-dialog :visible.sync="tipsForUploadingFiles" width="40%" top="10%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-info"></i>
                {{ $t("bookingSpace.other.uploadFiles") }}
            </div>
            <!--  提示语句 -->
            <span>{{ $t('bookingSpace.other.tipsForUploadingFiles') }}
                        </span>
            <span slot="footer" class="dialog-footer">

                <!--确定上传-->
            <el-button type="primary"
                       @click="submitUpload">
                {{ $t("common.confirmButton") }}
            </el-button>
                <!--取消上传-->
            <el-button type="primary" plain
                       @click="tipsForUploadingFiles = false">
                {{ $t("common.cancelButton") }}
            </el-button>
            </span>
        </el-dialog>

        <!--【提单下载】/【提单批量下载】对话框-->
        <el-dialog
                :visible.sync="preview.previewConfigDLDialogShow"
                custom-class="format-settings-dialog"
                width="50%">
            <bl-format-settings
                    :download-mode="true"
                    :initialBlNo="preview.previewBlNo"
                    :initialBookingHeadId="preview.previewBookingHeadId"
                    :initialFixedContainerType="preview.fixedContainerType"
                    :show-foot-btn="preview.showFootBtn"
                    :visible="preview.previewConfigDLDialogShow"
                    @cancel="preview.previewConfigDLDialogShow = false"
                    @download="handleBlDownload"
            />
        </el-dialog>
        <!--<el-dialog :visible.sync="preview.previewConfigDLDialogShow"
                   width="450px" top="10%" :show-close="false"
                   :before-close="handlePreviewDialogClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-s-order"> {{ $t("common.blDownload") }}</i>
            </div>
            <el-form :model="preview">
                <el-form-item :label="$t('booking.containerInfoType')" :label-width="preview.formLabelWidth">
                    <el-select v-model="preview.containerInfoType" :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option>
                        <el-option v-for="item in preview.containerInfoTypeOptions" :key="item.codeValue"
                                   :label="getCurLanguage() == 'en'? item.displayValue : item.displayValueCn"
                                   :value="item.codeValue">
                            <span style="float: left">{{ item.displayValueCn }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="preview.previewConfigDLDialogShow = false">{{ cancelButton }}</el-button>
                <el-button type="primary" @click="blDownloadAction()">{{ okButton }}</el-button>
            </div>
        </el-dialog>-->
        <!--【提单下载】对话框（提单之前已下载过，本次是否重新下载提示）-->
        <el-dialog :visible.sync="blDownloadShow" width="40%" top="10%"
                   :before-close="handleClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-info"></i>
                {{ $t("bookingSpace.other.bldownload") }}
            </div>
            <span>{{ $t('bookingSpace.other.reDownloadPrompt') }}
                        </span>
            <span slot="footer" class="dialog-footer">

            <!--提单下载是否重新下载提示框  下载-->
            <el-button type="primary"
                       @click="blDownloadBtnFromOssBtn(currentBookHead)">
                {{ $t('bookingSpace.other.download') }}
            </el-button>
                <!--提单下载是否重新下载提示框  重新下载-->
            <el-button type="primary" plain
                       @click="blDownloadBtnFromFrBtn(currentBookHead)">
                {{ $t('bookingSpace.other.reDownload') }}
            </el-button>
            </span>
        </el-dialog>

        <!--【预览】/【批量下载预览格式件】对话框-->
        <el-dialog
                :visible.sync="preview.previewConfigDialogShow"
                :width="preview.previewDialogWidth"
                custom-class="format-settings-dialog"
                top="3%">
            <bl-format-settings
                    :visible="preview.previewConfigDialogShow"
                    :initialBlNo="preview.previewBlNo"
                    :initialBookingHeadId="preview.previewBookingHeadId"
                    :initialFixedContainerType="preview.fixedContainerType"
                    :preview-mode="true"
                    :show-foot-btn="preview.showFootBtn"
                    @cancel="preview.previewConfigDialogShow = false"
                    @preview="handleBlPreview"
            />
        </el-dialog>
        <!--<el-dialog :visible.sync="preview.previewConfigDialogShow"
                   width="520px" top="10%" :show-close="false"
                   :before-close="handlePreviewDialogClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-s-order">{{ preview.previewData == null ? '' : preview.previewData.blNo }}{{ $t("common.Preview") }}</i>
            </div>
            <el-form :model="preview">
                <el-form-item :label="$t('booking.containerInfoType')" :label-width="preview.formLabelWidth">
                    <el-select v-model="preview.containerInfoType" :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option>
                        <el-option v-for="item in preview.containerInfoTypeOptions" :key="item.codeValue"
                                   :label="getCurLanguage() == 'en'? item.displayValue : item.displayValueCn"
                                   :value="item.codeValue">
                            <span style="float: left">{{ item.displayValueCn }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('booking.blTemplate')" :label-width="preview.formLabelWidth">
                    <el-select v-model="preview.blTemplate" :placeholder="$t('common.pleaseSelect')"
                               clearable filterable default-first-option>
                        <el-option v-for="item in preview.blTemplateOptions" :key="item.codeValue"
                                   :label="getCurLanguage() == 'en'? item.displayValue : item.displayValueCn"
                                   :value="item.codeValue">
                            <span style="float: left">{{ item.displayValueCn }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('booking.cargoDescOGSShow')" :label-width="preview.checkLabelWidth"
                              v-show="getCargoDescQGSShowFlag">
                    <el-checkbox-group v-model="preview.cargoDescQGSShowFlag">
                        <el-checkbox :label="$t('booking.cntrOgsShow')"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="preview.previewConfigDialogShow = false">{{ cancelButton }}</el-button>
                <el-button type="primary" @click="previewBlDownloadAction">{{ preViewButton }}</el-button>
            </div>
        </el-dialog>-->

        <!--【提单EDI报文导入】对话框-->
        <el-dialog
                :before-close="handleClose"
                :visible.sync="estimateUploadShow" top="5%"
                width="770px">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{ $t('booking.EDIMessageImport') }}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{ $t('booking.billInstruct') }}</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{ $t('estimate.uploadTips') }}</div>
            <el-row>
                <!--edi上传-->
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <i class="el-icon-s-order"></i>
                        <span>{{ $t('booking.EDIMessageUpload') }}</span>
                    </div>
                    <el-upload
                            class="upload-demo"
                            drag multipart
                            ref="estimatesUpload"
                            :on-success="uploadSuccess"
                            action=""
                            :limit=5
                            accept=".txt,.edi"
                            :http-request="handleUpload"
                            :file-list="fileList"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">{{ $t('common.dragUploadTips1') }}<em>{{ $t('common.dragUploadTips2') }}</em></div>
                    </el-upload>
                </el-col>
                <el-col style="width: 50%;">
                    <div class="cardTitle flex flex-align">
                        <i class="el-icon-s-order"></i>
                        <span>{{ $t('booking.importResult') }}</span>
                    </div>
                    <el-input v-model="importResult" type="textarea" readonly :rows="8"
                    />
                </el-col>
            </el-row>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="warning" icon="el-icon-refresh"
                       @click="resetFileList">{{ $t('common.resetButton') }}
            </el-button>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="uploadFile">{{ $t('estimate.uploadFiles') }}
            </el-button>

        </el-dialog>

        <!--【VGM上传】-【EXCEL上传】对话框-->
        <el-dialog :visible.sync="vgmContainerUploadShow" width="98%" top="10%" :close-on-click-modal="false">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/order-ico5.svg" alt="">
                VGM 上传
            </div>
            <el-table :data="vgmContainerUploadTableData" style="width: 100%" class="table"
                      :header-cell-style="{padding:'0px',height:'30px'}"
                      :row-style="{height:'30px'}"
                      :cell-style="{padding:'5px 0'}"
                      :empty-text="$t('common.noData')">
                <el-table-column min-width="60" type="index" :label="$t('booking.popover.no')" align="center"></el-table-column>
                <!--公司英文名称-->
                <el-table-column min-width="140" align="center">
                    <template slot="header">
                        <span>公司英文名称</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.shipperName"
                                  maxlength="140"
                                  @input="formatUpper('vgmContainerUploadTableData','shipperName',scope.row.shipperName,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--公司中文名称-->
                <el-table-column min-width="140" align="center">
                    <template slot="header">
                        <span>公司中文名称</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.shipperNameCn"
                                  maxlength="50"
                                  @input="formatUpper('vgmContainerUploadTableData','shipperNameCn',scope.row.shipperNameCn,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--船舶代码-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>船舶代码</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.vesselCode"
                                  maxlength="6"
                                  @input="formatUpper('vgmContainerUploadTableData','vesselCode',scope.row.vesselCode,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--航次-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span>航次</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.voyageNo"
                                  maxlength="10"
                                  @input="formatUpper('vgmContainerUploadTableData','voyageNo',scope.row.voyageNo,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--航段-->
                <el-table-column min-width="80" align="center">
                    <template slot="header">
                        <span>航段</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.voyageLeg"
                                  maxlength="5"
                                  @input="formatUpper('vgmContainerUploadTableData','voyageLeg',scope.row.voyageLeg,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--POL Code-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>POL Code</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.port"
                                  maxlength="5"
                                  @input="formatUpper('vgmContainerUploadTableData','port',scope.row.port,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--POD Code-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>POD Code</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.portDischarge"
                                  maxlength="5"
                                  @input="formatUpper('vgmContainerUploadTableData','portDischarge',scope.row.portDischarge,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--提单号-->
                <el-table-column min-width="180" align="center">
                    <template slot="header">
                        <span>提单号</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.blNo"
                                  maxlength="50"
                                  @input="formatUpper('vgmContainerUploadTableData','blNo',scope.row.blNo,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱号-->
                <el-table-column min-width="180" align="center">
                    <template slot="header">
                        <span>集装箱号</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.containerNo"
                                  maxlength="11"
                                  @input="formatUpper('vgmContainerUploadTableData','containerNo',scope.row.containerNo,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱型号-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span>集装箱型号</span>
                        <span></span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.containerType"
                                   placeholder=" "
                                   clearable filterable default-first-option
                                   @focus="containerTypeFocus">
                            <el-option v-for="item in containerTypeOptions"
                                       :key="item.equipmentCode" :label="item.equipmentCode"
                                       :value="item.equipmentCode"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--获得重量方法-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>获得重量方法</span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.vgmMethod"
                                   placeholder=" "
                                   clearable filterable default-first-option>
                            <el-option key="M1" label="M1" value="1"/>
                            <el-option key="M2" label="M2" value="2"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--                &lt;!&ndash;VGM称重单位&ndash;&gt;-->
                <!--                <el-table-column min-width="100" align="center">-->
                <!--                    <template slot="header">-->
                <!--                        <span>VGM称重单位</span>-->
                <!--                    </template>-->
                <!--                    <el-input v-model="vgmScaleDefault"  style="padding: 0 5px" readonly/>-->
                <!--                </el-table-column>-->
                <!--VGM验证重量(含柜重)-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>VGM验证重量(含柜重)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.vgmGrossWeight"
                                  @input="formatNumber('vgmContainerUploadTableData','vgmGrossWeight',scope.row.vgmGrossWeight,3,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--联系人-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span>联系人</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactName"
                                  maxlength="100"
                                  @input="formatUpper('vgmContainerUploadTableData','contactName',scope.row.contactName,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--联系邮箱-->
                <el-table-column min-width="150" align="center">
                    <template slot="header">
                        <span>联系邮箱</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactEmail"
                                  maxlength="100"
                                  @input="formatUpper('vgmContainerUploadTableData','contactEmail',scope.row.contactEmail,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--联系方式-->
                <el-table-column min-width="150" align="center">
                    <template slot="header">
                        <span>联系方式</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactTelephone"
                                  maxlength="20" style="padding: 0 5px"
                                  @input="formatUpper('vgmContainerUploadTableData','contactTelephone',scope.row.contactTelephone,scope.$index)"/>
                    </template>
                </el-table-column>
                <!--集装箱弹出框-删除按钮-->
                <el-table-column min-width="95" :label="$t('bookingSpace.container.operation')" align="center">
                    <template slot-scope="scope">
                        <img src="../../assets/image/icon/del1.svg"
                             @click="removeBkVgmContainer(scope.row,scope.$index)">
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
<!--                &lt;!&ndash;增加按钮&ndash;&gt;-->
                <!--                <el-button class="blue-button-text" @click="addBkVgmContainer">-->
                <!--                    增加-->
                <!--                </el-button>-->
                <!--提交按钮-->
                <el-button class="blue-button" @click="handleVgmUploadSubmit">
                    提交
                </el-button>
                <!--取消按钮-->
                <el-button class="blue-button" @click="handleVgmUploadCancel">
                    {{ cancelButton }}
                </el-button>
            </span>
        </el-dialog>
        <!--【VGM上传】-【VGM查看】对话框-->
        <el-dialog :visible.sync="uploadedVgmContainerShow" width="98%" top="10%" :close-on-click-modal="false">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/order-ico5.svg" alt="">
                VGM 查看
            </div>
            <el-table :data="uploadedVgmContainerTableData" style="width: 100%" class="table"
                      :header-cell-style="{padding:'0px',height:'30px'}"
                      :row-style="{height:'30px'}"
                      :cell-style="{padding:'5px 0'}"
                      :empty-text="$t('common.noData')">
                <el-table-column min-width="60" type="index" :label="$t('booking.popover.no')" align="center"></el-table-column>
                <!--公司英文名称-->
                <el-table-column min-width="140" align="center">
                    <template slot="header">
                        <span>公司英文名称</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.shipperName" readonly/>
                    </template>
                </el-table-column>
                <!--公司中文名称-->
                <el-table-column min-width="140" align="center">
                    <template slot="header">
                        <span>公司中文名称</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.shipperNameCn" readonly/>
                    </template>
                </el-table-column>
                <!--船舶代码-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>船舶代码</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.vesselCode" readonly/>
                    </template>
                </el-table-column>
                <!--航次-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span>航次</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.voyageNo" readonly/>
                    </template>
                </el-table-column>
                <!--航段-->
                <el-table-column min-width="80" align="center">
                    <template slot="header">
                        <span>航段</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.voyageLeg" readonly/>
                    </template>
                </el-table-column>
                <!--POL Code-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>POL Code</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.port" readonly/>
                    </template>
                </el-table-column>
                <!--提单号-->
                <el-table-column min-width="180" align="center">
                    <template slot="header">
                        <span>提单号</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.blNo" readonly/>
                    </template>
                </el-table-column>
                <!--集装箱号-->
                <el-table-column min-width="180" align="center">
                    <template slot="header">
                        <span>集装箱号</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.containerNo" readonly/>
                    </template>
                </el-table-column>
                <!--集装箱型号-->
                <el-table-column min-width="110" align="center">
                    <template slot="header">
                        <span>集装箱型号</span>
                        <span></span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.containerType" disabled
                                   clearable filterable default-first-option
                                   @focus="containerTypeFocus">
                            <el-option v-for="item in containerTypeOptions"
                                       :key="item.equipmentCode" :label="item.equipmentCode"
                                       :value="item.equipmentCode"/>
                        </el-select>
                    </template>
                </el-table-column>
                <!--获得重量方法-->
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>获得重量方法</span>
                    </template>
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.vgmMethod" disabled
                                   clearable filterable default-first-option>
                            <el-option key="M1" label="M1" value="1"/>
                            <el-option key="M2" label="M2" value="2"/>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" align="center">
                    <template slot="header">
                        <span>VGM验证重量(含柜重)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.vgmGrossWeight" readonly/>
                    </template>
                </el-table-column>
                <!--联系人-->
                <el-table-column min-width="100" align="center">
                    <template slot="header">
                        <span>联系人</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactName" readonly/>
                    </template>
                </el-table-column>
                <!--联系邮箱-->
                <el-table-column min-width="150" align="center">
                    <template slot="header">
                        <span>联系邮箱</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactEmail" readonly/>
                    </template>
                </el-table-column>
                <!--联系方式-->
                <el-table-column min-width="150" align="center">
                    <template slot="header">
                        <span>联系方式</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.contactTelephone" readonly/>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- VGM 上传失败信息对话框 -->
        <el-dialog
            :title="$t('common.errorTip')"
            :visible.sync="vgmUploadErrorDialogVisible"
            width="700px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body>
          <div
              v-html="vgmUploadErrorMessage"
              style="max-height: 400px; overflow-y: auto; line-height: 1.6; white-space: normal;"
          ></div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeVgmErrorDialog">
              {{ $t('common.confirm') }}
            </el-button>
          </span>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>

        <!-- 隐藏的文件输入框 -->
        <input
            ref="vgmFileInput"
            type="file"
            accept=".xls,.xlsx"
            style="display: none"
            @change="handleVgmFileChange"
        />
    </div>
</template>

<script>
import noDataView from "@/components/noDataView";
import resultBar from "@/components/resultBar";
import BlFormatSettings from '@/components/BlFormatSettings.vue';

export default {
    name: "billOfLading",
    computed: {
        searchButton() {//查询按钮
            return this.$t("common.searchButton");
        },
        resetButton() {//重置按钮
            return this.$t("common.resetButton");
        },
        editButton() {//编辑按钮
            return this.$t("common.editButton");
        },
        detailButton() {
            return this.$t('common.detail')
        },
        viewDetails() {
            return this.$t('common.viewDetails');
        },
        sendButton() {//发送船公司按钮
            return this.$t("common.sendButton");
        },
        historyButton() {//查看历史按钮
            return this.$t("common.historyButton");
        },
        findButton() {//搜索按钮
            return this.$t("common.findButton");
        },
        closeButton() {//关闭按钮
            return this.$t("common.closeButton");
        },
        confirmButton() {//确认按钮
            return this.$t("common.confirmButton");
        },
        newButton() {//新建按钮
            return this.$t("common.newButton");
        },
        preViewButton() {//预览按钮
            return this.$t("common.preViewButton");
        },
        okButton() {//确定按钮
            return this.$t("common.okButton");
        },
        cancelButton() {//取消按钮
            return this.$t("common.cancelButton");
        },
        blDownload() {//提单下载按钮
            return this.$t("common.blDownload");
        },
        BatchDownloadPreviewFormatting() {//批量下载预览格式件
            return this.$t("common.BatchDownloadPreviewFormatting");
        },
        blBatchDownload() {//提单批量下载按钮
            return this.$t("common.blBatchDownload");
        },
        guaranteeUpload() {//保函上传按钮
            return this.$t("common.guaranteeUpload");
        },
        exportDataButton() {
            return this.$t('common.exportTableData');
        },
        //批量操作按钮
        batchButton() {
          return this.$t('common.batch');
        },
        //批量VGM上传按钮
        batchUploadVgmButton() {
          return this.$t('common.batchUploadVgm');
        },
        //VGM上传按钮
        uploadVgmButton() {
            return this.$t('common.uploadVgm');
        },
        getSubmissionStatus() {// 获取操作步骤step2显示文字
            if (this.currentBookingHead == null || this.currentBookingHead.bkExtends.length <= 0) {
                return false;
            }
            let bkExtend = this.currentBookingHead.bkExtends[0];
            return bkExtend.guaranteeSubmissionStatus;
        },
        getReviewStatus() {// 获取操作步骤step3显示文字
            if (this.currentBookingHead == null || this.currentBookingHead.bkExtends.length <= 0) {
                return false;
            }
            let bkExtend = this.currentBookingHead.bkExtends[0];
            return bkExtend.guaranteeReviewStatus;
        },
        getStepActive() {// 根据当前操作提单的提交状态和审核状态获取所处流程步骤
            const that = this;
            that.fileLimit = 5 - this.tableUpLoadedGuranteeFile.length;
            if (this.currentBookingHead == null) {
                return 0;
            }
            let bkContainers = this.currentBookingHead.bkContainers;
            let bkExtends = this.currentBookingHead.bkExtends;
            // 赋值审核步骤属性 1：上传SI信息  2：保函未提交/已提交  3：保函未审核/审核中/审核不通过/审核通过
            if (bkContainers != null && bkContainers.length > 0) {
                if (bkExtends != null && bkExtends.length > 0) {
                    let bkExtend = bkExtends[0];
                    if (bkExtend.guaranteeSubmissionStatus != null && bkExtend.guaranteeSubmissionStatus == 1) {
                        if (bkExtend.guaranteeReviewStatus == null || bkExtend.guaranteeReviewStatus == 0) {
                            return 2;// 保函已提交，未审核/审核中
                        } else if (bkExtend.guaranteeReviewStatus == 1) {
                            return 1;// 审核不通过，重新提交，提交状态回退到未提交
                        } else {
                            return 3;// 保函已提交且审核通过
                        }
                    } else {
                        return 1;//已上传SI信息，保函未提交（step1已完成）
                    }
                } else {
                    return 1;//已上传SI信息，保函未提交（step1已完成）
                }
            } else {
                return 0;
            }
        },
        getCargoDescQGSShowFlag() {
            if (this.preview == null
                || this.preview.previewData == null
                || this.preview.previewData.pol == null) {
                return false;
            }
            console.log(this.preview.previewData.pol.substring(0, 2));
            return this.preview.blTemplate === 1
                && this.preview.previewData.pol.length >= 2
                && this.preview.previewData.pol.substring(0, 2) == 'TH';
        }
    },
    components: {
        noDataView,
        resultBar,
        BlFormatSettings,
    },
    data() {
        return {
            importResult: "",
            estimateUploadShow: false,  //控制edi文件上传框是否显示
            isSearchClick: false,
            isSendClick: false,
            isVVLSearchClick: false,
            showViewFlag: "card",       //控制数据是否展开显示 card：卡片  table：表格

            search: {
                vesselCode: "",
                voyage: "",
                voyageNo: "",
                loadingPort: "",
                dischargePort: "",
                sailingTimeStart: "", //开航时间从
                sailingTimeEnd: "",
                crateTimeStart: "", //创建时间从
                crateTimeEnd: "",
                bookingNo: "", //订舱号
                billNo: "",
                blStatus: "", //提单状态
                vesselName: "", //船舶名称
                voyageLeg: "" //航段
            },
            bkSearch: {
                vesselCode: "",
                voyage: "",
                voyageNo: "",
                loadingPort: "",
                dischargePort: "",
                sailingTimeStart: "", //开航时间从
                sailingTimeEnd: "",
                crateTimeStart: "", //创建时间从
                crateTimeEnd: "",
                bookingNo: "", //订舱号
                billNo: "",
                bookingStatus: "", //订舱状态
                vesselName: "", //船舶名称
                voyageLeg: "" //航段
            },
            boatListShow: false,
            voyageOptions: [],
            portOptions: [],
            bookingStatusOptions: [],
            containerTypeOptions: [],
            cargoDescAndHscodeRequiredRouteList: [],// 箱信息货名及HSCODE必填航线信息
            blStatusOptions: [
                {codeValue: 0, displayValueCn: "等待", displayValue: "WAITING"},
                {codeValue: 1, displayValueCn: "确认", displayValue: "CONFIRM"},
                {codeValue: 2, displayValueCn: "拒绝", displayValue: "REFUSE"},
                {codeValue: 3, displayValueCn: "空", displayValue: "BLANK"},
                {codeValue: 4, displayValueCn: "草稿", displayValue: "DRAFT"},
            ],
            deliveryMethodOptions: [    //单证类型下拉选项
                {codeValue: 1, displayValueCn: "正本提单", displayValue: "OBL"},
                {codeValue: 2, displayValueCn: "海运单", displayValue: "SW"},
                {codeValue: 3, displayValueCn: "电放提单", displayValue: "TLX"}
            ],
            releaseStatusOptions: [     //放单状态
                {codeValue: "", displayValueCn: "未处理", displayValue: "UNHANDLED"},
                {codeValue: 1, displayValueCn: "正本提单已签发", displayValue: "OBL released"},
                {codeValue: 2, displayValueCn: "已电放", displayValue: "TLX released"},
                {codeValue: 3, displayValueCn: "海运单已签发", displayValue: "SW released"},
                {codeValue: 4, displayValueCn: "取消放单", displayValue: "CANCEL & WITHDRAW"}
            ],
            blReleaseFlagOptions: [
                {codeValue: 0, displayValueCn: "放货", displayValue: "RELEASED"},
                {codeValue: 1, displayValueCn: "扣货", displayValue: "DETAINED"},
            ],
            showNoDataView: true,
            tableData: [],
            tableDataAdd: [],
            pageCount: 5,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            popData: [],
            popPageCount: 5,
            popPageNum: 1,
            popPageSize: 5,
            popTotal: 7,

            boatList: [],
            dialogVisible: false,
            popTableSelection: [],  //存放vvl弹框中鼠标点击选中的值
            bkTableSelection: [],   //存放订舱信息表格中鼠标点击选中的值
            tableSelection: [],      //存放提单信息表格中勾选的记录
            guaranteeUploadDialogVisible: false,
            currentBlId: null,
            currentBookingHead: null,
            blDownloadShow: false,
            currentBookHead: {},

            // 新增：是否为批量VGM上传模式
            isBatchVgmUploadMode: false,
            // 待上传VGM提单ID
            vgmUploadBookingHeadId: null,
            // 待上传VGM文件列表
            vgmFileList: [],
            // 待上传的VGM信息
            vgmContainerUploadTableData: [],
            // 已上传的VGM信息
            uploadedVgmContainerTableData: [],
            vgmContainerUploadShow: false,
            uploadedVgmContainerShow: false,
            vgmScaleDefault: 'KGS',// 默认称重单位 千克
            vgmUploadErrorDialogVisible: false,   // 控制错误弹窗显隐
            vgmUploadErrorMessage: '',            // 存储格式化后的错误信息

            // 待上传文件列表
            fileList: [],
            //允许上传的文件数，初始为5个
            fileLimit: 5,
            // 保函提交及审核进度条激活控制
            stepActive: 0,
            dataForm: {
                name: '',
                file: null
            },
            hasFile: false,
            tableUpLoadedGuranteeFile: [],//存放当前操作提单已上传的附件记录
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            formLabelWidth: '120px',
            tipsForUploadingFiles: false,

            preview: {
                batchOperationFlag: false,          // 批量操作标识（用来判断是单票下载的箱信息设置还是批量的）
                previewDialogWidth: "90%",          // 【预览】/【提单下载】对话框-宽度
                formLabelWidth: '150px',
                checkLabelWidth: '250px',
                previewConfigDialogShow: false,     // 【预览】对话框-是否显示
                previewConfigDLDialogShow: false,   // 【提单下载】对话框-是否显示

                showFootBtn: false,                 // 【预览】/【提单下载】对话框-是否显示组件底部按钮组
                containerInfoType: 7,               // 【预览】/【提单下载】对话框-箱信息类型（默认为箱号/封号/箱尺寸）
                containerInfoTypeOptions: [         // 【预览】/【提单下载】对话框-箱信息类型选项
                    {codeValue: 7, displayValueCn: "箱号/封号/箱尺寸", displayValue: "(CTN NO./Seal NO./CTN Size)"},
                    {codeValue: 9, displayValueCn: "箱号/箱型/封号/件毛体", displayValue: "(CTN NO./CTN Type/Seal NO./PCS&G.W&VOL)"},
                    {codeValue: 11, displayValueCn: "箱号/封号/箱型/件毛皮体", displayValue: "(CTN NO./Seal NO./CTN Type/PCS&G.W&T.W&VOL)"},
                ],
                blTemplate: 0,                      // 【预览】/【提单下载】对话框-模板类型（默认为0-提单确认件）
                blTemplateOptions: [                // 【预览】/【提单下载】对话框-模板类型选项
                    {codeValue: 0, displayValueCn: "（干线）提单确认件", displayValue: "(Trunk)BL DRAFT"},
                    {codeValue: 1, displayValueCn: "（支线）提单确认件", displayValue: "(Feeder)BL DRAFT"},
                ],
                cargoDescQGSShowFlag: false,

                previewData: null,         //当前正在预览的提单数据
                previewBlNo: null,
                previewBookingHeadId: null,
                fixedContainerType: null
            },
            tableToolbar: {
                perfect: true,
                zoom: true,
                custom: true,
                slots: {
                    buttons: 'toolbar_buttons'
                }
            },

            tableColumn: [
                {align: 'center', type: 'checkbox', width: 40},
                {align: 'center', type: 'seq', title: 'booking.no', width: 60, sortable: true,},//序号
                {
                    align: 'center', field: 'blStatus', title: 'booking.blStatus', minWidth: 150, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_blStatus'
                    }
                },//提单状态
                {align: 'center', field: 'bkNo', title: 'booking.bkNo', minWidth: 180, sortable: true,},//订舱号
                {
                    align: 'center', field: 'blNo', title: 'booking.blNo', minWidth: 180, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_blNo'
                    }
                },//提单号
                {
                    align: 'center', field: 'vesselName', title: 'booking.vesselName', minWidth: 180, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_vesselName'
                    }
                },//船名
                {align: 'center', field: 'voyage', title: 'booking.voyage', minWidth: 100, sortable: true,},//航次
                {
                    align: 'center', field: 'polName', title: 'booking.pol', minWidth: 120, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_polName'
                    }
                },//装货港
                {align: 'center', field: 'polEtd', title: 'booking.polEtd', minWidth: 100, sortable: true,},//ETD
                {
                    align: 'center', field: 'podName', title: 'booking.pod', minWidth: 120, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_podName'
                    }
                },//卸货港
                {align: 'center', field: 'podEta', title: 'booking.podEta', minWidth: 100, sortable: true,},//ETA
                {
                    align: 'center', field: 'delName', title: 'booking.del', minWidth: 120, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_delName'
                    }
                },//目的港
                {
                    align: 'center', field: 'transportationTerms', title: 'bookingSpace.booking.transportationTerms', minWidth: 130, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_transportationTerms'
                    }
                },//运输条款
                {
                    align: 'center', field: 'paidType', title: 'bookingSpace.booking.paidType', minWidth: 120, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_paidType'
                    }
                },//付费方式
                {
                    align: 'center', field: 'deliveryDocumentMethod', title: 'bookingSpace.bl.deliveryDocumentMethod', minWidth: 120, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_deliveryDocumentMethod'
                    }
                },//提单类型
                {
                    align: 'center', field: 'releaseStatus', title: 'bookingSpace.bl.releaseStatus', minWidth: 140, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_releaseStatus'
                    }
                },//放单状态
                {
                    align: 'center', field: 'blReleaseFlag', title: 'bookingSpace.bl.blReleaseFlag', minWidth: 160, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_blReleaseFlag'
                    }
                },//放货状态
                {
                    align: 'center', field: 'guaranteeSubmissionStatus', title: 'booking.guaranteeSubmissionStatus', minWidth: 180, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_guaranteeSubmissionStatus'
                    }
                },//保函提交状态
                {
                    align: 'center', field: 'guaranteeReviewStatus', title: 'booking.guaranteeReviewStatus', minWidth: 160, sortable: true,
                    slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                        default: 'column_guaranteeReviewStatus'
                    }
                },//保函审核状态
                {align: 'center', field: 'updatedDtmLoc', title: 'booking.updatedDtmLoc', minWidth: 160, sortable: true,},//修改时间
                {align: 'center', field: 'remark', title: 'booking.remark', minWidth: 150},//备注
                {
                    align: 'center', field: 'menu', title: 'common.menuColumn', minWidth: 250, fixed: 'right',
                    titlePrefix: {
                        icon: 'el-icon-s-tools'
                    },
                    slots: {
                        default: 'operate_default'
                    }
                }
            ]
        };
    },
    methods: {
        /**
         * 【查询】按钮功能实现
         */
        searchBtnClick() {
            if (this.isSearchClick) {
                return;
            }
            this.isSearchClick = true;
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                                                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                                                text: this.$t('message.searching'),    //加载动画的文字
                                                spinner: 'el-icon-loading',             // 引入的loading图标
                                                background: "rgb(0,0,0,0.1)",
                                                // target: document.querySelector(".searchComposite") // 设置加载动画区域
                                            });
            let that = this;

            this.$refs.popover.showPopper = false;
            this.axios({
                           method: 'post',
                           url: '/api/booking/blQuery',
                           data: {
                               vesselCode: this.search.vesselCode,
                               voyageNo: this.search.voyage,
                               pol: this.search.loadingPort,
                               pod: this.search.dischargePort,
                               saillingDateFrom: this.search.sailingTimeStart === "" ? "" : this.formatDate(
                                   {date: this.search.sailingTimeStart, formatStr: 'yyyy-MM-dd'}
                               ),
                               saillingDateTo: this.search.sailingTimeEnd === "" ? "" : this.formatDate(
                                   {date: this.search.sailingTimeEnd, formatStr: 'yyyy-MM-dd'}
                               ),
                               createTimeFrom: this.search.crateTimeStart === "" ? "" : this.formatDate(
                                   {date: this.search.crateTimeStart, formatStr: 'yyyy-MM-dd'}
                               ),
                               createTimeTo: this.search.crateTimeEnd === "" ? "" : this.formatDate(
                                   {date: this.search.crateTimeEnd, formatStr: 'yyyy-MM-dd'}
                               ),
                               bkNo: this.search.bookingNo,
                               blNo: this.search.billNo,
                               blStatus: this.search.blStatus,
                               pageNum: this.pageNum,
                               pageSize: this.pageSize
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                that.loadingtuo.close();
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.showNoDataView = false;
                    this.tableData = this.resetTableDataUnChecked(response.data.object.list);
                    this.total = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.isSearchClick = false;
            }).catch(error => {
                that.loadingtuo.close();
                this.isSearchClick = false;
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
            // 每次查询后清空勾选提单记录
            this.tableSelection = [];
        },
        /**
         * 重置表格记录选中状态为未选中状态
         * @param tableData
         * @returns {*}
         */
        resetTableDataUnChecked(tableData) {
            tableData.forEach((data) => {
                data.checked = false;
            });
            return tableData;
        },

        /**
         * 【重置】按钮功能实现
         */
        resetBtnClick() {
            this.search.vesselCode = "";
            this.search.vesselCode = "";
            this.search.voyage = "";
            this.search.voyageNo = "";
            this.search.loadingPort = "";
            this.search.dischargePort = "";
            this.search.sailingTimeStart = ""; //开航时间从
            this.search.sailingTimeEnd = "";
            this.search.crateTimeStart = ""; //创建时间从
            this.search.crateTimeEnd = "";
            this.search.bookingNo = ""; //订舱号
            this.search.billNo = "";
            this.search.blStatus = ""; //提单状态
            this.search.vesselName = ""; //船舶名称
            this.search.voyageLeg = ""; //航段
        },

        /**
         * 【全选】/【反选】按钮功能实现
         * @param isCheck
         */
        checkAllBtnClick(isCheck) {
            this.tableSelection = [];
            if (isCheck) {
                // 全选
                this.tableData.forEach((item,
                                        index) => {
                    item.checked = true;
                    this.checkOneMethod(index, true)
                })
            } else {
                // 反选
                this.tableData.forEach((item,
                                        index) => {
                    let cur = item.checked;
                    item.checked = !cur;
                    this.checkOneMethod(index, !cur)
                })
            }
        },
        /**
         * 提单数据选中/取消选中处理
         * @param index
         * @param type
         */
        checkOneMethod(index, type) {
            let curData = this.tableData[index];
            if (type) {
                //选中
                this.tableSelection.push(curData);
                // 新增表格视图下全选控制
                if (this.$refs.tableData) {
                    this.$refs.tableData.setCheckboxRow(curData, type);
                }
            } else {
                //取消选中
                this.tableSelection.forEach((item,
                                             index) => {
                    if (item.bookingHeadId === curData.bookingHeadId) {
                        this.tableSelection.splice(index, 1);
                    }
                })
                // 新增表格视图下反选控制
                if (this.$refs.tableData) {
                    this.$refs.tableData.toggleCheckboxRow(curData);
                }
            }
        },

        /**
         * 【提单EDI报文导入】按钮功能实现
         * @constructor
         */
        BookingEdiImportBtn() {
            this.estimateUploadShow = true;
        },
        /**
         * 【提单EDI报文导入】对话框-【重置】按钮功能实现
         */
        resetFileList() {
            this.fileList = [];
            this.importResult = "";
        },
        /**
         * 【提单EDI报文导入】对话框-【关闭】功能实现
         * @param done
         */
        handleClose(done) {
            // 弹框关闭前，清空待上传文件列表
            this.fileList = [];
            this.importResult = "";
            this.currentBookHead = null;
            this.blDownloadShow = false;
            // this.filePicList = [];
            done();
        },
        /**
         * 【提单EDI报文导入】对话框-【增加待上传文件】功能实现
         * @param param
         */
        handleUpload(param) {
            this.fileImport.append('file', param.file);
        },
        /**
         * 【提单EDI报文导入】对话框-【上传文件】按钮功能实现
         */
        uploadFile() {
            this.fileImport = new FormData();
            this.$refs.estimatesUpload.submit();
            // this.$refs.estimatePicturesUpload.submit();
            this.fileImport.append('isSi', true);
            this.fileImport.append('language', localStorage.getItem('locale'));
            // 上传确认
            this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                distinguishCancelAndClose: true,
                confirmButtonText: this.$t("common.confirmButton"),
                cancelButtonText: this.$t("common.cancelButton")
            }).then(() => {
                if (!this.fileImport.entries().next().value) {
                    // 启动进度条
                    this.loadingOverLay = this.$loading({
                                                            lock: false,
                                                            text: this.$t('estimate.uploading'),
                                                            spinner: 'el-icon-loading',
                                                            background: 'rgba(0,0,0,0.1)'
                                                        });
                    this.axios.post('/api/booking/ediImport', this.fileImport, {
                        headers: {'Content-Type': 'multipart/form-data', 'Accept-language': localStorage.getItem("locale")},
                        timeout: 200000,
                    }).then(response => {
                        // // 清空待上传附件列表
                        // this.fileList = [];
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "407") {
                            this.showMessage(false, this.responseCode, "warning");
                        } else if (response.data.backCode === "200") {
                            this.importResult = this.responseCode;
                        } else {
                            this.importResult = this.responseCode;
                        }
                        this.loadingOverLay.close();
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.$alert(this.responseCode.replaceAll(';', ' <br/> '), this.$t('estimate.uploadCompleted'), {
                                customClass: 'uploadMsg',
                                confirmButtonText: this.$t('common.okButton'),
                                dangerouslyUseHTMLString: true
                            });
                        } else {
                            this.showMessage(false, error, "error");
                        }
                        this.loadingOverLay.close();
                    });
                    // 上传完毕，清空文件存储列表
                    this.fileImport = new FormData();
                } else {
                    this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                }
            });
        },
        /**
         * 【提单EDI报文导入】对话框-上传文件成功回调处理
         * @param res
         * @param file
         * @param fileList
         */
        uploadSuccess(res, file, fileList) {
            // 清除上传文件列表
            this.$refs.estimatesUpload.clearFiles();
        },

        /**
         * 【提单EDI报文说明下载】按钮功能实现
         * @constructor
         */
        BookingEdiInstructBtn() {
            window.location.href = "/api/booking/download?urlLink=http://zg-website.oss-cn-shanghai.aliyuncs.com/ediImport/bookingHead.xls&fileName=IFTMIN_Y_提单信息确认.xls";
        },

        /**
         * 【批量提交SI信息】按钮功能实现
         */
        SumitSiInformationBtn() {
            var bookingHeadIds = [];
            this.tableSelection.forEach((bookingHead) => {
                bookingHeadIds.push(bookingHead.bookingHeadId);
            });
            if (bookingHeadIds.length == 0) {
                this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                return;
            }
            this.axios.post('/api/booking/submitSis', {'bookingHeadIds': bookingHeadIds}, {
                headers: {'Content-Type': 'application/json', 'Accept-language': localStorage.getItem("locale")},
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.$alert(this.responseCode, this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton"),
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        /**
         * 【预览】/【批量下载预览格式件】按钮功能实现
         * @param data
         */
        previewBtnClick(data) {
            // 判断是批量下载提单预览件还是单票提单预览
            if (data == null) {
                // 批量下载提单预览件，校验是否勾选数据
                if (this.tableSelection.length <= 0) {
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }

                // 设置批量标识为true
                this.preview.batchOperationFlag = true;

                // 提单格式设置组件中需要展示底部按钮组
                this.preview.showFootBtn = true;
                // 设置弹框宽度占页面50%
                this.preview.previewDialogWidth = "50%";

                // 打开提单预览格式设置对话框
                this.preview.previewConfigDialogShow = true;
            } else {
                // 单票提单预览，记录当前预览的提单数据
                this.preview.previewData = data;
                this.preview.previewBlNo = data.blNo;// 单独记录预览提单号
                this.preview.previewBookingHeadId = data.bookingHeadId;// 单独记录预览提单ID
                // 提单格式设置组件不需要展示底部按钮组
                this.preview.showFootBtn = false;
                // 设置弹框宽度占页面90%
                this.preview.previewDialogWidth = "90%";
                let pod = data.pod;
                // 若为指定航线，货名和HSCODE必填
                if (Array.isArray(this.cargoDescAndHscodeRequiredRouteList) && this.cargoDescAndHscodeRequiredRouteList.length > 0) {
                    // 校验数组中是否存在至少一个对象：pod不为空、不为null/undefined
                    const hasFixedContainerType = this.cargoDescAndHscodeRequiredRouteList.some(item => {
                        return item?.codeValue === pod;
                    });

                    if (hasFixedContainerType) {
                        this.preview.fixedContainerType = "12";
                    } else {
                        this.preview.fixedContainerType = null;
                    }
                }
                // 打开提单预览格式设置对话框
                this.preview.previewConfigDialogShow = true;
            }
        },
        /**
         * 【批量下载预览格式件】对话框-【下载】按钮功能实现
         * @param data
         */
        handleBlPreview(data) {
            // 接收对话框中用户选择的模板类型
            this.preview.blTemplate = data.previewTemplateType;
            // 接收对话框中用户选择的箱信息类型
            this.preview.containerInfoType = data.containerInfoType;
            // 接收对话框中用户选择的货描显示设置
            this.preview.cargoDescQGSShowFlag = data.cargoDescQGSShowFlag;
            // 下载预览格式件
            this.previewBlDownloadAction();
        },
        /**
         * 提单预览格式件下载功能
         */
        previewBlDownloadAction() {
            // 校验批量操作标识
            if (this.preview.batchOperationFlag) {
                // 批量下载提单预览格式件
                this.doBatchPreviewBlDownloadAction();
            } /*else {
                //单票预览
                this.doSinglePreviewBlDownloadAction();
            }*/

            // 清空当前正在预览提单数据
            this.preview.previewData = null;
            this.preview.previewBlNo = null;
            this.preview.previewBookingHeadId = null;
        },
        /**
         * 单票提单预览功能
         */
        doSinglePreviewBlDownloadAction() {
            let bookingHead = this.preview.previewData;
            let url = "";
            this.axios({
                           method: 'post',
                           url: '/api/booking/billOfLadingPreview',
                           data: {
                               bookingHeadId: bookingHead.bookingHeadId,
                               blNo: bookingHead.blNo,
                               containerInfoType: this.preview.containerInfoType,
                               blTemplate: this.preview.blTemplate,
                               cargoDescQGSShowFlag: this.preview.cargoDescQGSShowFlag
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    url = response.data.object.toString();
                    // this.$router.push({
                    //     name: 'billOfLading/ladingPreview',
                    //     params: {fr_cpt_url: url}
                    // });
                    // 关闭弹框
                    this.preview.previewConfigDialogShow = false;
                    var route = this.$router.resolve({
                                                         name: 'billOfLading/ladingPreview',
                                                     });
                    // 将传递参数存到session中
                    sessionStorage.setItem("PASSING_PARAMETERS", url);
                    // 打开提单预览页面
                    window.open(route.href, '_blank');
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 批量提单预览格式件下载功能
         */
        doBatchPreviewBlDownloadAction() {
            var bookingHeadIds = [];
            this.tableSelection.forEach((bookingHead) => {
                bookingHeadIds.push(bookingHead.bookingHeadId);
            });
            
            // 添加调试信息
            console.log('批量下载预览格式件 - 选中的提单数量:', this.tableSelection.length);
            console.log('批量下载预览格式件 - 提单ID列表:', bookingHeadIds);
            
            // 启动加载状态
            this.loadingOverLay = this.$loading({
                lock: false,
                text: this.$t('message.downloading'),
                spinner: 'el-icon-loading',
                background: 'rgba(0,0,0,0.1)'
            });
            
            let urls = "";
            this.axios({
                           method: 'post',
                           url: '/api/booking/billOfLadingPreviews',
                           data: {
                               bookingHeadId: bookingHeadIds.join(','),
                               blNo: "",
                               containerInfoType: this.preview.containerInfoType,
                               blTemplate: this.preview.blTemplate,
                               cargoDescQGSShowFlag: this.preview.cargoDescQGSShowFlag
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    urls = response.data.object.toString();
                    console.log('批量下载预览格式件 - 返回的URLs:', urls);
                    var arr = urls.split(",");
                    console.log('批量下载预览格式件 - 解析后的URL数组:', arr);
                    arr.forEach((url) => {
                        if (url != "") {
                            console.log('批量下载预览格式件 - 下载URL:', url);
                            this.saveg2(url);
                        }
                    });
                    this.showMessage(false, '批量下载预览格式件成功', "success");
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.loadingOverLay.close();
            }).catch(error => {
                console.error('批量下载预览格式件 - 请求失败:', error);
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                this.loadingOverLay.close();
            });
            this.preview.previewConfigDialogShow = false;
            this.preview.batchOperationFlag = false;
        },

        /**
         * 【提单下载】/【提单批量下载】按钮功能实现
         * @param data
         */
        blDownloadBtnClick(data) {
            // 判断是批量下载提单还是单票下载提单
            if (data == null) {
                // 赋值批量下载标识
                this.preview.batchOperationFlag = true;
            } else {
                // 单票下载提单，记录要下载的提单数据
                this.preview.previewData = data;
                this.preview.previewBlNo = data.blNo;// 单独记录待下载提单号
                this.preview.previewBookingHeadId = data.bookingHeadId;// 单独记录待下载提单ID

                let pod = data.pod;
                // 若为指定航线，货名和HSCODE必填
                if (Array.isArray(this.cargoDescAndHscodeRequiredRouteList) && this.cargoDescAndHscodeRequiredRouteList.length > 0) {
                    // 校验数组中是否存在至少一个对象：pod不为空、不为null/undefined
                    const hasFixedContainerType = this.cargoDescAndHscodeRequiredRouteList.some(item => {
                        return item?.codeValue === pod;
                    });

                    if (hasFixedContainerType) {
                        this.preview.fixedContainerType = "12";
                    } else {
                        this.preview.fixedContainerType = null;
                    }
                }
            }

            // 设置组件中需要展示底部按钮组
            this.preview.showFootBtn = true;

            // 打开提单下载格式设置弹框
            this.preview.previewConfigDLDialogShow = true;
        },
        /**
         * 【提单下载】/【提单批量下载】对话框-【下载】按钮功能实现
         * @param data
         */
        handleBlDownload(data) {
            // 接收对话框中用户选择的箱信息类型
            this.preview.containerInfoType = data.containerInfoType;
            // 接收对话框中用户选择的货描显示设置
            this.preview.cargoDescQGSShowFlag = data.cargoDescQGSShowFlag;
            // 下载提单
            this.blDownloadAction();
        },
        /**
         * 提单下载功能
         */
        blDownloadAction() {
            // 校验批量操作标识
            if (this.preview.batchOperationFlag) {
                // 批量下载选中提单
                this.doBatchBlDownloadAction();
            } else {
                // 下载当前操作的提单
                this.doSingleBlDownloadAction();
            }
        },
        /**
         * 单票提单下载功能
         */
        doSingleBlDownloadAction() {
            let bookingHead = this.preview.previewData;
            // 提单下载条件是否满足校验
            if (!this.validateBLDownload(bookingHead)) {
                return;
            }
            let fileUrl = null;
            this.axios({
                           method: 'get',
                           url: '/api/booking/bookingHeadCheck/' + bookingHead.bookingHeadId + '/' + this.preview.containerInfoType,
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    // 获取返回的oss地址，若之前未下载过提单，则获取为null
                    fileUrl = response.data.object;
                    if (fileUrl != null && fileUrl !== "") {//附件表存在该提单下载记录,打开重复下载提示框
                        this.currentBookHead = bookingHead;
                        this.currentBookHead.ossUrl = fileUrl;
                        this.blDownloadShow = true;
                    } else {//附件表不存在该提单下载记录,直接从帆软下载提单
                        this.blDownloadBtnFromFrBtn(bookingHead);
                    }
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
            this.preview.previewConfigDLDialogShow = false;
        },
        /**
         * 提单批量下载功能
         */
        doBatchBlDownloadAction() {
            var bookingHeadIds = [];
            let blNoAndUrls = new Map();
            let failedBls = [];
            this.tableSelection.forEach((bookingHead) => {
                bookingHeadIds.push(bookingHead.bookingHeadId);
            });
            // 校验是否勾选数据
            if (bookingHeadIds.length <= 0) {
                this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                return;
            }

            // 提单下载前校验
            this.axios({
                           method: 'post',
                           url: '/api/booking/bookingHeadBatchCheck' + '/' + this.preview.containerInfoType,
                           data: {
                               bookingHeadIds: JSON.stringify(bookingHeadIds),
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                // 启动进度条
                this.loadingOverLay = this.$loading({
                                                        lock: false,
                                                        text: this.$t('message.downloading'),
                                                        spinner: 'el-icon-loading',
                                                        background: 'rgba(0,0,0,0.1)'
                                                    });
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {//检验成功，允许打印
                    // 批量下载
                    this.axios({
                                   method: 'post',
                                   url: '/api/booking/bookingHeadBatchDownload',
                                   data: {
                                       bookingHeadIds: JSON.stringify(bookingHeadIds),
                                   },
                                   headers: {
                                       'Accept-language': localStorage.getItem("locale")
                                   }
                               }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            blNoAndUrls = response.data.object;
                            for (var key in blNoAndUrls) {
                                if (blNoAndUrls[key] == null) {
                                    // this.showMessage(false, this.$t('message.blBatchDownloadFailed',{blNo: key}), "error");
                                    failedBls.push(key);
                                }
                                this.saveg(blNoAndUrls[key]);
                            }
                            // 若存在下载失败，提示下载失败提单信息
                            if (failedBls.length > 0) {
                                this.$alert(this.$t('message.blBatchDownloadFailed', {blNo: failedBls.join('，')}), this.$t('bookingSpace.other.downloadFailed'), {
                                    confirmButtonText: this.$t('common.okButton')
                                });
                            }
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        this.loadingOverLay.close();
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                        this.loadingOverLay.close();
                    });
                } else {//校验失败，提示不允许打印提单
                    this.$alert(this.responseCode.replaceAll(';', ' <br/> '), this.$t('bookingSpace.other.downloadFailed'), {
                        confirmButtonText: this.$t('common.okButton'),
                        dangerouslyUseHTMLString: true
                    });
                    this.loadingOverLay.close();
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
            this.preview.previewConfigDLDialogShow = false;
            this.preview.batchOperationFlag = false;
        },
        /**
         * 提单下载是否允许校验
         * @param bookingHead
         * @returns {boolean}
         */
        validateBLDownload(bookingHead) {
            let message = "";
            // 1.校验单证类型是否为海运单或电放
            if (bookingHead.deliveryDocumentMethod == null
                || (bookingHead.deliveryDocumentMethod != 2
                    && bookingHead.deliveryDocumentMethod != 3)) {
                message = this.$t('bookingSpace.other.downloaFailed2');
            }
            // 2.校验提单状态是否为确认状态
            if (bookingHead.blStatus == null || bookingHead.blStatus != 1) {
                message = this.$t('bookingSpace.other.downloaFailed1');
            }
            // 3.校验保函是否为审核通过状态
            if (bookingHead.bkExtends == null
                || bookingHead.bkExtends[0] == null
                || bookingHead.bkExtends[0].guaranteeReviewStatus != 2) {
                message = this.$t('bookingSpace.other.downloaFailed3');
            }
            // 4.校验提单放货状态是否为放货  0:放货 1：扣货
            if (bookingHead.blReleaseFlag) {
                message = this.$t('bookingSpace.other.downloaFailed4');
            }
            // 5.校验提单放单状态是否为放单
            if (bookingHead.releaseStatus == null
                || (bookingHead.releaseStatus != 1
                    && bookingHead.releaseStatus != 2
                    && bookingHead.releaseStatus != 3)) {
                message = this.$t('bookingSpace.other.downloaFailed5');
            }
            // 6.已签发不给下载
            if (bookingHead.releaseStatus == 1) {
                message = this.$t('bookingSpace.other.downloaFailed6');
            }

            if (message != "") {
                this.$alert(message, this.$t('bookingSpace.other.downloadFailed'), {
                    confirmButtonText: this.$t('common.okButton'),
                });
                return false;
            }
            return true;
        },

        /**
         * 【保函上传】按钮功能实现
         * @param bookingHead
         */
        guaranteeUploadBtnClick(bookingHead) {
            // 清空已上传保函列表
            this.tableUpLoadedGuranteeFile = [];
            // 还原审核步骤
            this.stepActive = 0;
            // 获取当前操作的提单对象
            this.currentBookingHead = bookingHead;
            let currentBlId = this.currentBookingHead.bookingHeadId;

            // 刷新当前提单已上传附件列表
            this.refreshTableUpLoadedGuranteeFile(currentBlId);

            // 打开上传弹框
            this.guaranteeUploadDialogVisible = true;
        },
        /**
         * 【保函上传】对话框-上传成功后刷新已上传附件表格内容
         * @param relationId
         */
        refreshTableUpLoadedGuranteeFile(relationId) {
            const that = this;
            if (relationId == null || relationId === "") {
                return;
            }

            this.axios({
                           method: "get",
                           url: "/api/booking/uploadedFileSearch/" + relationId,
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(function (response) {
                that.tableUpLoadedGuranteeFile = response.data.object;
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        /**
         * 【VGM上传】-【EXCEL上传】按钮功能实现
         * @param param
         * @param data
         */
        handleVgmUpload(param, data) {
            // 标记为单票上传模式（关键！）
            this.isBatchVgmUploadMode = false;
            // 清空VGM上传信息
            this.vgmContainerUploadTableData = [];
            // 记录当前上传VGM的提单ID
            this.vgmUploadBookingHeadId = data.bookingHeadId;

            // 校验上传文件类型
            try {
                if (!this.validateVgmFileTypeBeforeUpload(param.file)) {
                    throw new Error("EndForEach");
                }
            } catch (e) {
                if (e.message !== "EndForEach") {
                    this.showMessage(false, e, "error");
                } else {
                    this.$message({
                                      message: this.$t('message.validateFileTypeFailed', {fileName: param.file.name}),
                                      type: 'warning'
                                  });
                    return;
                }
            }

            let fd = new FormData();
            fd.append('file', param.file); // 传文件
            fd.append('bookingHeadId', this.vgmUploadBookingHeadId);

            // 开启加载组件
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                                                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                                                text: this.$t('common.uploading'),             // 加载动画的文字
                                                spinner: 'el-icon-loading',                     // 引入的loading图标
                                                background: "rgb(0,0,0,0.1)",
                                            });
            let that = this;

            this.axios.post('/api/booking/bkVgmContaierDataUpload', fd, {
                headers: {'Content-Type': 'multipart/form-data', 'Accept-language': localStorage.getItem("locale")},//定义内容格式,很重要
                timeout: 20000,
            }).then(response => {
                that.loadingtuo.close();

                const backCode = response.data.backCode;
                const responseMessage = response.data.backMessage;
                const responseData = response.data.object || [];

                // 无论成功失败，先保存返回的数据（用于后续展示）
                this.vgmContainerUploadTableData = responseData;

                if (backCode === "200" && Array.isArray(responseData) && responseData.length > 0) {
                  // 成功：直接展示数据
                  this.vgmContainerUploadShow = true;
                } else {
                  // 失败：使用自定义 dialog 展示错误信息
                  let errorMessage = responseMessage || this.$t('common.unknownError');
                  const formattedMessage = String(errorMessage)
                      .split(';')
                      .map(s => s.trim())
                      .filter(s => s.length > 0)
                      .join('<br/>');

                  // 保存错误信息并打开弹窗
                  this.vgmUploadErrorMessage = formattedMessage;
                  this.vgmUploadErrorDialogVisible = true;
                }
            }).catch(error => {
                if (error.data) {
                    let responseCode = error.data.backMessage;
                    this.showMessage(false, responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                that.loadingtuo.close();
            });
        },
        /**
         * VGM上传失败回调处理
         */
        handleVgmUploadError(error, file) {
            this.showMessage(false, '文件' + file.name + '上传失败', "error");
        },
        /**
         * 【VGM上传】-【VGM查看】按钮功能实现
         * @param data
         */
        viewVgmBtnClick(data) {
            this.uploadedVgmContainerTableData = [];
            // 校验当前提单是否有上传VGM数据
            if (data.bkVgmContainers != null && data.bkVgmContainers.length > 0) {
                this.uploadedVgmContainerTableData = data.bkVgmContainers;
                this.uploadedVgmContainerShow = true;
            } else {
                this.showMessage(false, '提单' + data.blNo + '未上传VGM数据', "warning");
            }
        },
        /**
         * 【VGM上传】-【EXCEL上传】对话框-【删除】功能实现
         */
        removeBkVgmContainer(row, index) {
            if (!row) {
                return;
            }

            this.$confirm("是否确定删除第" + (index + 1) + "行VGM信息?", this.$t("common.pleaseConfirm"), {
                distinguishCancelAndClose: true,
                confirmButtonText: this.$t("common.deleteButton"),
                cancelButtonText: this.$t("common.cancelButton")
            }).then(() => {
                //删除
                this.vgmContainerUploadTableData.splice(index, 1)
            })
        },
        /**
         * 【VGM上传】-【EXCEL上传】对话框-【取消】按钮功能实现
         */
        handleVgmUploadCancel() {
            this.vgmContainerUploadTableData = [];
            this.vgmContainerUploadShow = false;
        },
        /**
         * 【VGM上传】-【EXCEL上传】对话框-【提交】功能实现
         */
        handleVgmUploadSubmit() {
            // 校验VGM表格中是否有数据
            if (this.vgmContainerUploadTableData == null || this.vgmContainerUploadTableData.length <= 0) {
                return;
            }

            // 开启加载组件
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                                                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                                                text: this.$t('common.committing'),             // 加载动画的文字
                                                spinner: 'el-icon-loading',                     // 引入的loading图标
                                                background: "rgb(0,0,0,0.1)",
                                            });
            let that = this;

            // 判断是单票还是批量
            if (this.isBatchVgmUploadMode) {
              // ========== 批量模式：调用多票提交接口 ==========
              this.axios({
                method: 'post',
                url: '/api/booking/bkVgmContainersBatchSubmit',
                data: this.vgmContainerUploadTableData,
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(response => {
                that.loadingtuo.close();
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                  this.showMessage(false, this.responseCode, "success");
                  // 提交成功，关闭VGM对话框
                  this.vgmContainerUploadShow = false;
                  // 清空待上传VGM数据
                  this.vgmContainerUploadTableData = [];

                  // 刷新当前提单VGM数据
                  if (this.vgmUploadBookingHeadId != null && this.vgmUploadBookingHeadId !== "") {
                    this.refresh(this.vgmUploadBookingHeadId);
                  }
                } else {
                  // 失败：使用自定义 dialog 展示错误信息
                  let errorMessage = this.responseCode || this.$t('common.unknownError');
                  const formattedMessage = String(errorMessage)
                      .split(';')
                      .map(s => s.trim())
                      .filter(s => s.length > 0)
                      .join('<br/>');

                  // 保存错误信息并打开弹窗
                  this.vgmUploadErrorMessage = formattedMessage;
                  this.vgmUploadErrorDialogVisible = true;
                }
              }).catch(error => {
                that.loadingtuo.close();
                if (error.data) {
                  this.responseCode = error.data.backMessage;
                  this.showMessage(false, this.responseCode, "error");
                } else {
                  this.showMessage(false, error, "error");
                }
              });

            } else {
              // ========== 单票模式：调用原单票提交接口 ==========
              this.axios({
                method: 'post',
                url: '/api/booking/bkVgmContaierDataSubmit',
                data: {
                  vgmContainerList: JSON.stringify(this.vgmContainerUploadTableData),
                  bookingHeadId: this.vgmUploadBookingHeadId
                },
                headers: {
                  'Accept-language': localStorage.getItem("locale")
                }
              }).then(response => {
                that.loadingtuo.close();
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                  this.showMessage(false, this.responseCode, "success");
                  // 提交成功，关闭VGM对话框
                  this.vgmContainerUploadShow = false;
                  // 清空待上传VGM数据
                  this.vgmContainerUploadTableData = [];

                  // 刷新当前提单VGM数据
                  if (this.vgmUploadBookingHeadId != null && this.vgmUploadBookingHeadId !== "") {
                    this.refresh(this.vgmUploadBookingHeadId);
                  }
                } else {
                  // 失败：使用自定义 dialog 展示错误信息
                  let errorMessage = this.responseCode || this.$t('common.unknownError');
                  const formattedMessage = String(errorMessage)
                      .split(';')
                      .map(s => s.trim())
                      .filter(s => s.length > 0)
                      .join('<br/>');

                  // 保存错误信息并打开弹窗
                  this.vgmUploadErrorMessage = formattedMessage;
                  this.vgmUploadErrorDialogVisible = true;
                }
              }).catch(error => {
                that.loadingtuo.close();
                if (error.data) {
                  this.responseCode = error.data.backMessage;
                  this.showMessage(false, this.responseCode, "error");
                } else {
                  this.showMessage(false, error, "error");
                }
              });
            }
        },
        /**
         * 【VGM上传】-【EXCEL上传】对话框-条成功后刷新表格数据
         * @param bookingHeadId
         */
        refresh(bookingHeadId) {
            this.axios({
                           method: 'post',
                           url: '/api/booking/blQuery',
                           data: {
                               bookingHeadId: bookingHeadId
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    let bookingHeadList = this.resetTableDataUnChecked(response.data.object.list);
                    if (bookingHeadList != null && bookingHeadList.length > 0) {
                        console.log("最新VGM数据：", bookingHeadList[0].bkVgmContainers);
                        this.tableData.forEach((item) => {
                            if (item.bookingHeadId === bookingHeadId) {
                                item.bkVgmContainers = bookingHeadList[0].bkVgmContainers;
                            }
                        });
                    }
                } else {
                    this.showMessage(false, "提单VGM数据刷新失败，请手动刷新页面获取最新数据", "error");
                }
            }).catch(error => {
                this.showMessage(false, "提单VGM数据刷新失败，请手动刷新页面获取最新数据", "error");
            });
        },

        /**
         * 【编辑】按钮功能实现
         * @param bookingHead
         */
        editBtnClick(bookingHead) {
            //查询最新数据
            this.axios({
                           method: 'post',
                           url: '/api/booking/blQuery',
                           data: {
                               bookingHeadId: bookingHead.bookingHeadId
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    if (response.data.object.list.length > 0) {
                        // this.$router.push({
                        //     name: 'billOfLading/ladingDetails',
                        //     params: {
                        //         bookingHeadInfo: response.data.object.list[0]
                        //     }
                        // });
                        var route = this.$router.resolve({
                                                             name: 'billOfLading/ladingDetails',
                                                         });
                        let bookingHeadInfo = response.data.object.list[0];
                        // 将传递参数存到session中
                        sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(bookingHeadInfo));
                        // 打开提单详情页面
                        window.open(route.href, '_blank')
                    }
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        /**
         * 表格/卡片视图切换功能实现
         * @param data
         */
        handleViewStyle(data) {
            // 切换展示风格
            this.showViewFlag = data.value;
            // 将展示风格存到session中
            localStorage.setItem("VIEW_STYLE", this.showViewFlag);
        },

        /**
         * 多个url批量下载文件方法
         */
        saveg(url) {
            if (url == null || url === "") {
                return;
            }
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';  // 防止影响页面
            iframe.style.height = 0;  // 防止影响页面
            iframe.src = `${url}`;
            document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
            // 5分钟之后删除
            setTimeout(() => {
                iframe.remove()
            }, 5 * 60 * 1000)
        },

        /**
         * 多个url批量下载文件方法
         */
        saveg2(url) {
            if (url == null || url === "") {
                return;
            }
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';  // 防止影响页面
            iframe.style.height = 0;  // 防止影响页面

            // ============== 核心修改：替换内网IP为同源地址 ==============
            // 固定替换你的内网IP+端口，保留后面的路径
            const newUrl = url.replace('http://172.16.10.157:8080', '');
            // ========================================================

            iframe.src = newUrl;
            document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
            // 5分钟之后删除
            setTimeout(() => {
                iframe.remove()
            }, 5 * 60 * 1000)
        },

        //下载按钮-通过oss下载
        blDownloadBtnFromOssBtn(bookingHead) {
            this.loadingOverLay = this.$loading({
                                                    lock: false,
                                                    text: this.$t('message.downloading'),
                                                    spinner: 'el-icon-loading',
                                                    background: 'rgba(0,0,0,0.1)'
                                                });
            this.fileLinkToStreamDownload(bookingHead.ossUrl, bookingHead.blNo);
            this.blDownloadShow = false;
            this.loadingOverLay.close();
            /*let url = "";
                let fileName = bookingHead.blNo;
                this.axios({
                    method: 'get',
                    url: '/api/booking/bookingHeadDownloadOSS/' + bookingHead.bookingHeadId,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        url = response.data.object.toString();
                        this.fileLinkToStreamDownload(url, fileName);
                        this.blDownloadShow = false;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.loadingOverLay.close();
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.loadingOverLay.close();
                });*/
        },
        //首次下载/重新下载-通过FR上传到OSS后,通过OSS下载
        blDownloadBtnFromFrBtn(bookingHead) {
            this.loadingOverLay = this.$loading({
                                                    lock: false,
                                                    text: this.$t('message.downloading'),
                                                    spinner: 'el-icon-loading',
                                                    background: 'rgba(0,0,0,0.1)'
                                                });
            let url = "";
            let fileName = bookingHead.blNo;
            this.axios({
                           method: 'get',
                           url: '/api/booking/bookingHeadDownloadFr/' + bookingHead.bookingHeadId,
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    url = response.data.object.toString();
                    this.fileLinkToStreamDownload(url, fileName);
                    this.blDownloadShow = false;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.loadingOverLay.close();
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                this.loadingOverLay.close();
            });
        },
        //通过url下载文件
        async fileLinkToStreamDownload(url,
                                       fileName) {
            let link = document.createElement('a');
            link.href = url;
            link.download = fileName; //加上下载的文件名
            if (url.indexOf('?') === -1) { //这步不加应该也好使，但我没试
                url += '?download'
            }
            link.click();
            link.remove();
        },


        handlePreviewDialogClose() {
            // 清空当前正在预览提单数据
            this.preview.previewData = null;
        },

        handleRemove(file,
                     fileList) {
            if (!fileList.length) {
                this.hasFile = false;
            }
            this.dataForm.file = null;
            // 同步更新 fileList
            this.fileList = fileList;
        },
        // 上传附件预览功能
        handlePreview(file) {
            console.log(file);
        },

        handleChange(file,
                     fileList) {
            // 同步更新 fileList，确保 validateAllFilesBeforeUpload 可以获取到文件列表
            // 注意：即使 fileList.length >= 2，也要更新 fileList，以便后续校验能获取到正确的文件列表
            this.fileList = fileList;
            
            if (fileList.length >= 2) {
                return;
            }
            if (fileList.length === 1) {
                this.hasFile = true;
            }
            this.dataForm.file = file;
        },

        /**
         * 【保函上传】自定义保函上传方法
         */
        handleSubmit(param) {
            // 在提交前先校验所有文件
            if (!this.validateAllFilesBeforeUpload()) {
                return; // 校验失败，阻止提交
            }

            let fd = new FormData();
            fd.append('bookingHeadId', this.currentBookingHead.bookingHeadId);
            fd.append('file', param.file); // 传文件

            this.axios.post('/api/booking/guaranteeUpload', fd, {
                headers: {'Content-Type': 'multipart/form-data', 'Accept-language': localStorage.getItem("locale")},//定义内容格式,很重要
                timeout: 20000,
            }).then(response => {
                // 清空待上传附件列表
                this.fileList = [];
                let responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    // this.showGuaranteeUploadDialog = false;
                    // 刷新数据状态
                    this.currentBookingHead = response.data.object;
                    // 刷新附件列表
                    this.refreshTableUpLoadedGuranteeFile(this.currentBookingHead.bookingHeadId);
                    this.showMessage(false, responseCode, "success");
                } else {
                    this.showMessage(false, responseCode, "error");
                }
            }).catch(error => {
                // 特别处理413错误（请求实体过大）
                if (error.response && error.response.status === 413) {
                    this.$message({
                        message: this.$t('message.guaranteeUpload413Error', {fileName: param.file.name}),
                        type: 'error'
                    });
                    return;
                }
                if (error.data) {
                    let responseCode = error.data.backMessage;
                    this.showMessage(false, responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        uploadFiles() {
            // 在提交前先校验所有文件
            if (!this.validateAllFilesBeforeUpload()) {
                return; // 校验失败，阻止提交，不显示确认对话框
            }
            
            // 所有文件校验通过，显示上传确认对话框
            this.tipsForUploadingFiles = true;
        },
        /**
         * 【保函上传】校验所有待上传文件
         * @returns {boolean} 所有文件是否都通过校验
         */
        validateAllFilesBeforeUpload() {
            // 优先从 el-upload 组件实例获取文件列表，如果没有则使用 this.fileList
            let filesToValidate = [];
            
            // 尝试从 el-upload 组件实例获取文件列表
            if (this.$refs.upload) {
                // el-upload 组件的 uploadFiles 属性包含所有文件
                if (this.$refs.upload.uploadFiles && this.$refs.upload.uploadFiles.length > 0) {
                    filesToValidate = this.$refs.upload.uploadFiles;
                }
            }
            
            // 如果从组件实例获取不到，尝试使用 this.fileList
            if (filesToValidate.length === 0 && this.fileList && this.fileList.length > 0) {
                filesToValidate = this.fileList;
            }
            
            // 如果还是获取不到，尝试从 dataForm.file 获取（单个文件的情况）
            if (filesToValidate.length === 0 && this.dataForm.file) {
                filesToValidate = [this.dataForm.file];
            }
            
            if (!filesToValidate || filesToValidate.length === 0) {
                this.$message({
                    message: this.$t('estimate.pleaseSelectFiles2Upload'),
                    type: 'warning'
                });
                return false;
            }

            let invalidFiles = [];
            
            // 遍历所有文件进行校验
            for (let i = 0; i < filesToValidate.length; i++) {
                const fileItem = filesToValidate[i];
                // el-upload 组件中，文件对象可能是 {raw: File, ...} 或直接是 File
                const file = fileItem.raw || fileItem;
                
                if (!file) {
                    continue;
                }

                // 校验文件类型
                if (!this.validateFileTypeBeforeUpload(file)) {
                    invalidFiles.push({
                        fileName: file.name,
                        reason: this.$t('message.validateFileTypeFailed', {fileName: file.name})
                    });
                    continue;
                }

                // 校验文件大小（限制5MB）
                let fileSize = (file.size / 1024 / 1024).toFixed(2);
                const isLt5M = parseFloat(fileSize) < 5;
                if (!isLt5M) {
                    invalidFiles.push({
                        fileName: file.name,
                        reason: this.$t('message.guaranteeUploadSizeLimit', {fileName: file.name, fileSize: (fileSize + 'M')})
                    });
                }
            }

            // 如果有校验失败的文件，显示错误信息并阻止提交
            if (invalidFiles.length > 0) {
                // 格式化错误信息，每个文件的校验失败信息独占一行
                let errorMessage = '<div style="text-align: left; line-height: 1.8;">';
                errorMessage += '<strong>' + this.$t('message.guaranteeUploadValidationFailed') + '</strong><br/><br/>';
                invalidFiles.forEach((item, index) => {
                    errorMessage += `<strong>${index + 1}. ${item.fileName}</strong><br/>`;
                    errorMessage += `&nbsp;&nbsp;&nbsp;&nbsp;${item.reason}<br/><br/>`;
                });
                errorMessage += '</div>';
                
                // 使用 $alert 弹出框显示所有错误信息，支持 HTML 换行
                this.$alert(errorMessage, this.$t('message.guaranteeUploadValidationTitle'), {
                    confirmButtonText: this.$t('common.okButton'),
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                });
                
                return false;
            }

            return true;
        },
        submitUpload() {
            this.tipsForUploadingFiles = false;

            // 在提交前先校验所有文件
            if (!this.validateAllFilesBeforeUpload()) {
                return; // 校验失败，阻止提交
            }
            
            // 所有文件校验通过，执行提交
            this.$refs.upload.submit();
        },
        /**
         * 【保函上传】校验上传文件类型是否符合要求
         */
        validateFileTypeBeforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            // .jpg,.jpeg,.png,.pdf,.PDF
            const extension1 = testmsg === 'jpg';
            const extension2 = testmsg === 'JPG';
            const extension3 = testmsg === 'jpeg';
            const extension4 = testmsg === 'JPEG';
            const extension5 = testmsg === 'png';
            const extension6 = testmsg === 'PNG';
            const extension7 = testmsg === 'pdf';
            const extension8 = testmsg === 'PDF';
            // const isLt2M = file.size / 1024 / 1024 < 10
            return !(!extension1 &&
                !extension2 &&
                !extension3 &&
                !extension4 &&
                !extension5 &&
                !extension6 &&
                !extension7 &&
                !extension8);
        },
        /**
         * 【保函上传】校验上传文件类型是否符合要求
         */
        validateVgmFileTypeBeforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            // .jpg,.jpeg,.png,.pdf,.PDF
            const extension1 = testmsg === 'xls';
            const extension2 = testmsg === 'xlsx';
            // const isLt2M = file.size / 1024 / 1024 < 10
            return !(!extension1 &&
                !extension2);
        },
        /**
         * 【保函上传】删除已上传的保函附件
         */
        handleDelete(index,
                     row) {
            this.$confirm(this.$t('message.guaranteeDeleteConfirm'), this.$t('common.pleaseConfirm'), {
                confirmButtonText: this.$t('common.okButton'),
                cancelButtonText: this.$t('common.cancelButton'),
                type: 'warning'
            }).then(() => {
                this.axios({
                               method: 'post',
                               url: '/api/booking/guaranteeRemove',
                               data: row,
                               headers: {
                                   'Accept-language': localStorage.getItem("locale")
                               }
                           }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.tableUpLoadedGuranteeFile.splice(index, 1);
                        this.$message({
                                          type: 'success',
                                          message: this.$t('message.guaranteeDeleteSucceed')
                                      });
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            });
        },
        /**
         * 【保函上传】打开已上传的保函附件(新页面)
         */
        openFile(url) {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            a.click();
        },

        /**
         * 提单查询页-【查看历史】按钮点击
         */
        viewHistoryBtnClick() {
            this.$alert("开发中...", this.$t("common.tips"), {
                confirmButtonText: this.$t("common.okButton")
            });
        },
        /**
         * 提单查询页: 船名航次VVL弹框数据 船名/搜索/关闭/确定 按钮点击
         */
        showVesselList() {//提单查询页/订舱查询dialog-【船名】下拉数据查询
            this.boatListShow = true;
            this.axios({
                           method: 'get',
                           url: '/api/codedict/getVesselList',
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.boatList = response.data.object;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        vvlSearch() {//提单查询页-【搜索】按钮点击
            if (this.isVVLSearchClick) {
                return;
            }
            this.isVVLSearchClick = true;
            this.axios({
                           method: 'post',
                           url: '/api/voyagePlan/getVVLEntity',
                           data: {
                               voyageNo: this.search.voyageNo,
                               voyageLeg: this.search.voyageLeg,
                               vesselName: this.search.vesselName,
                               vesselCode: this.search.vesselCode,
                               pageNum: this.popPageNum,
                               pageSize: this.popPageSize
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.popData = response.data.object.list;
                    this.popTotal = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.isVVLSearchClick = false;
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                this.isVVLSearchClick = false;
            });
        },
        closePopoverView() {//提单查询页/VVL弹框-【关闭】按钮点击
            this.$refs.popover.showPopper = false;
        },
        popConfirm() {//提单查询页-【确认】按钮点击
            if (this.popTableSelection.length !== 0) {//获取弹框中最后选中的记录
                this.popRowDblclick(this.popTableSelection[0]);
            }
            this.$refs.popover.showPopper = false;
        },
        /**
         * 订舱查询dialog: 查询/重置/ 船名航次VVL弹框 船名/搜索/关闭/确定 按钮点击
         */
        bkVvlSearch() {//订舱查询dialog-【查询】按钮点击
            if (this.isVVLSearchClick) {
                return;
            }
            this.isVVLSearchClick = true;
            this.axios({
                           method: 'post',
                           url: '/api/voyagePlan/getVVLEntity',
                           data: {
                               voyageNo: this.bkSearch.voyageNo,
                               voyageLeg: this.bkSearch.voyageLeg,
                               vesselName: this.bkSearch.vesselName,
                               vesselCode: this.bkSearch.vesselCode,
                               pageNum: this.popPageNum,
                               pageSize: this.popPageSize
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.popData = response.data.object.list;
                    this.popTotal = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.isVVLSearchClick = false;
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                this.isVVLSearchClick = false;
            });
        },
        bkSearchBtnClick() {//订舱查询dialog-【查询】按钮点击
            this.$refs.popover.showPopper = false;
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                                                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                                                text: this.$t("message.searching"),    //加载动画的文字
                                                spinner: 'el-icon-loading',             // 引入的loading图标
                                                background: "rgb(0,0,0,0.1)",
                                                target: document.querySelector(".bkSelectDialog") // 设置加载动画区域
                                            });
            let that = this;
            this.axios({
                           method: 'post',
                           url: '/api/booking/bookingHeadQuery',
                           data: {
                               vesselCode: this.bkSearch.vesselCode,
                               voyageNo: this.bkSearch.voyage,
                               pol: this.bkSearch.loadingPort,
                               pod: this.bkSearch.dischargePort,
                               saillingDateFrom: this.bkSearch.sailingTimeStart === "" ? "" : this.formatDate(
                                   {date: this.bkSearch.sailingTimeStart, formatStr: 'yyyy-MM-dd'}
                               ),
                               saillingDateTo: this.bkSearch.sailingTimeEnd === "" ? "" : this.formatDate(
                                   {date: this.bkSearch.sailingTimeEnd, formatStr: 'yyyy-MM-dd'}
                               ),
                               createTimeFrom: this.bkSearch.crateTimeStart === "" ? "" : this.formatDate(
                                   {date: this.bkSearch.crateTimeStart, formatStr: 'yyyy-MM-dd'}
                               ),
                               createTimeTo: this.bkSearch.crateTimeEnd === "" ? "" : this.formatDate(
                                   {date: this.bkSearch.crateTimeEnd, formatStr: 'yyyy-MM-dd'}
                               ),
                               bkNo: this.bkSearch.bookingNo,
                               blNo: this.bkSearch.billNo,
                               pageNum: this.pageNum,
                               pageSize: this.pageSize
                           },
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(response => {
                that.loadingtuo.close();
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.showNoDataView = false;
                    this.tableDataAdd = response.data.object.list;
                    this.total = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                that.loadingtuo.close();
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });

            this.bkTableSelection = [];
        },
        bkPopConfirm() {//订舱查询 VVL弹框-【确定】按钮点击
            if (this.popTableSelection.length !== 0) {//获取弹框中最后选中的记录
                this.bkRowDblclick(this.popTableSelection[0]);
            }
            this.$refs.popover.showPopper = false;
        },
        bkResetBtnClick() {//订舱查询dialog-【重置】按钮点击
            this.bkSearch.vesselCode = "";
            this.bkSearch.vesselCode = "";
            this.bkSearch.voyage = "";
            this.bkSearch.voyageNo = "";
            this.bkSearch.loadingPort = "";
            this.bkSearch.dischargePort = "";
            this.bkSearch.sailingTimeStart = ""; //开航时间从
            this.bkSearch.sailingTimeEnd = "";
            this.bkSearch.crateTimeStart = ""; //创建时间从
            this.bkSearch.crateTimeEnd = "";
            this.bkSearch.bookingNo = ""; //订舱号
            this.bkSearch.billNo = "";
            this.bkSearch.bookingStatus = ""; //订舱状态
            this.bkSearch.vesselName = ""; //船舶名称
            this.bkSearch.voyageLeg = ""; //航段
        },
        bkConfirm() {//订舱查询dialog-OK按钮点击,将选中订舱数据带到提单编辑页面
            if (this.bkTableSelection.length === 0) {
                this.$alert(this.$t("message.pleaseSelect2Edit"), this.$t("common.tips"), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }
            //校验选中记录订舱状态是否为订舱确认/锁定/解锁状态
            if (this.bkTableSelection[0].bookingStatus != 1
                && this.bkTableSelection[0].bookingStatus != 3
                && this.bkTableSelection[0].bookingStatus != 4) {
                this.$alert(this.$t("message.cannotMakeBL"), this.$t("common.tips"), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }

            this.dialogVisible = false;
            this.$router.push({
                                  name: 'billOfLading/ladingDetails',
                                  params: {
                                      bookingHeadInfo: this.bkTableSelection.length === 0 ? null : this.bkTableSelection[0]
                                  }
                              });
        },
        /************************************ 分页条 ************************************
         * 提单数据表格分页条
         */
        handleDemand() {
            this.searchBtnClick();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1;
            this.handleDemand();
            this.$emit("backTop");
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.handleDemand();
            this.$emit("backTop");
        },
        /**
         * 提单数据表格分页条(表格视图)
         */
        handleTablePageChange({currentPage, pageSize}) {
            this.pageNum = currentPage;
            this.pageSize = pageSize;
            this.searchBtnClick();
        },

        /**
         * 提单查询页: 船名航次VVL弹框数据分页条
         */
        popHandleDemand() {
            this.vvlSearch();
        },
        popHandleSizeChange(val) {
            this.popPageSize = val;
            this.popPageNum = 1;
            this.popHandleDemand();
            this.$emit("backTop");
        },
        popHandleCurrentChange(val) {
            this.popPageNum = val;
            this.popHandleDemand(1);
            this.$emit("backTop");
        },
        /**
         * 订舱查询dialog: 船名航次VVL弹框分页条
         */
        bkPopHandleDemand() {
            this.bkVvlSearch();
        },
        bkPopHandleSizeChange(val) {
            this.popPageSize = val;
            this.bkPopHandleDemand();
            this.$emit("backTop");
        },
        bkPopHandleCurrentChange(val) {
            this.popPageNum = val;
            this.bkPopHandleDemand(1);
            this.$emit("backTop");
        },

        /************************************ 行记录点击事件 ************************************
         * 提单数据表格行记录点击事件
         */
        rowClick(row) {
            this.tableSelection = [row];
        },
        /**
         * 提单查询页: 船名航次VVL弹框行记录点击事件:
         *  某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值提单查询页船名航次输入框
         */
        checkBoatData(boat) {// 某行船名记录被点击时，赋值船名及船舶英文名到VVL查询输入框中
            this.search.vesselCode = boat.vesselCode;
            this.search.vesselName = boat.vesselName;
            this.boatListShow = false
        },
        popRowDblclick(row) {
            this.search.vesselCode = row.vesselCode;
            this.search.voyage = row.voyageNo + row.voyageLeg;
            this.$refs.popover.showPopper = false;
        },
        popRowClick(row) {
            this.popTableSelection = [row];
        },
        /**
         * 订舱查询dialog: 船名航次VVL弹框行记录点击事件:
         *  某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值dialog船名航次输入框
         */
        bkRowDblclick(row) {
            this.bkSearch.vesselCode = row.vesselCode;
            this.bkSearch.voyage = row.voyageNo + row.voyageLeg;
            this.$refs.popover.showPopper = false;
        },
        /**
         * 订舱信息表格行记录点击事件
         *   鼠标选中某条订舱记录时,记录该行数据,用于对该条记录做后续操作
         */
        bkRowClick(row) {
            this.bkTableSelection = [row];
        },

        /**
         * 订舱数据表格勾选事件，将表格中选中订舱数据添加进勾选列表中
         */
        handleTableDataChecked({checked}) {
            // 清空数据checked状态
            this.tableData.forEach((item) => {
                item.checked = false;
            });
            // 先清空订舱数据多选列表
            this.tableSelection = [];
            const records = this.$refs.tableData.getCheckboxRecords();
            // 更新卡片视图下数据选中状态
            records.forEach((item) => {
                item.checked = true;
            });
            // 更新表格勾选的订舱信息
            this.tableSelection = records;
        },
        /**
         * 表格数据导出
         */
        exportDataEvent() {
            this.$refs.tableData.openExport({types: ['csv']})
        },

        /************************************ 基础数据下拉框赋值 ************************************/
        bkCheckBoatData(boat) {//订舱查询dialog-船名航次VVL弹框【船名】下拉框赋值
            this.bkSearch.vesselCode = boat.vesselCode;
            this.bkSearch.vesselName = boat.vesselName;
            this.boatListShow = false
        },
        /**
         * 港口数据初始化
         * [param: refresh] 是否重新获取港口数据标志（true：重新请求港口数据 | false：不重新请求
         */
        portFocus(refresh) {//【港口】下拉数据查询
            if (this.portOptions == null || this.portOptions.length <= 0) {
                // 若港口数据为空，也要重新请求数据
                refresh = true;
            }

            if (refresh) {
                // 重新获取港口数据
                const _this = this;
                this.axios({
                               method: "get",
                               url: "/api/port/getAllPortList",
                               headers: {
                                   'Accept-language': localStorage.getItem("locale")
                               }
                           }).then(function (response) {
                    _this.portOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            }
        },
        bookingStatusFocus() {//【订舱状态】查询
            if (this.bookingStatusOptions == null || this.bookingStatusOptions.length <= 0) {
                const _this = this;
                this.axios({
                               method: "get",
                               url: "/api/codedict/getBookingStatusList",
                               headers: {
                                   'Accept-language': localStorage.getItem("locale")
                               }
                           }).then(function (response) {
                    _this.bookingStatusOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            }
        },
        /**
         * 货名及HSCODE必填航线信息
         */
        initCargoDescAndHscodeRequiredRoutes() {
            const _this = this;
            this.axios({
                method: "get",
                url: "/api/codedict/getCargoDescAndHscodeRequiredRouteList",
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(function (response) {
                _this.cargoDescAndHscodeRequiredRouteList = response.data.object
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 箱型
         */
        containerTypeFocus() {
            const _this = this;
            this.axios({
                           method: "get",
                           url: "/api/codedict/getContainerTypeList",
                           headers: {
                               'Accept-language': localStorage.getItem("locale")
                           }
                       }).then(function (response) {
                _this.containerTypeOptions = response.data.object
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        /************************************ 接口返回数据国际化显示 *************************************/
        getBlStatusDisplayValue(item) {
            let value = {};
            this.blStatusOptions.forEach((option) => {
                if (option.codeValue == item.blStatus) {
                    value = option;
                }
            });
            if (value !== {}) {
                return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
            } else {
                return item.blStatus;
            }
        },
        getdeliveryMethodDisplayValue(item) {
            let value = {};
            this.deliveryMethodOptions.forEach((option) => {
                if (option.codeValue == item.deliveryDocumentMethod) {
                    value = option;
                }
            });
            if (value !== {}) {
                return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
            } else {
                return item.deliveryDocumentMethod;
            }
        },
        getReleaseStatusDisplayValue(item) {
            let value = {};
            this.releaseStatusOptions.forEach((option) => {
                if (option.codeValue == item.releaseStatus) {
                    value = option;
                }
            });
            if (value !== {}) {
                return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
            } else {
                return item.releaseStatus;
            }
        },
        getBlReleaseFlagDisplayValue(item) {
            let value = {};
            this.blReleaseFlagOptions.forEach((option) => {
                if (option.codeValue == item.blReleaseFlag) {
                    value = option;
                }
            });
            if (value !== {}) {
                return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
            } else {
                return item.blReleaseFlag;
            }
        },
        getBookingStatusDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.bookingStatusDisplay : item.bookingStatusDisplayCn;
        },
        getPolDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.polName : item.polNameCn;
        },
        getPodDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.podName : item.podNameCn;
        },
        getDelDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.delName : item.delNameCn;
        },
        /**
         * 提交状态国际化
         * @param data
         * @returns {VueI18n.TranslateResult|null}
         */
        getGuaranteeSubmissionStatusValue(data) {
            if (data == null) {
                return null;
            }
            if (data.bkExtends == null || data.bkExtends.length < 1) {
                return null;
            }
            if (data.bkExtends[0].guaranteeSubmissionStatus == 1) {
                return this.$t('bookingSpace.other.committed');
            } else {
                return this.$t('bookingSpace.other.uncommitted');
            }
        },
        /**
         * 保函审核状态国际化
         * @param data
         * @returns {VueI18n.TranslateResult|null}
         */
        getGuaranteeReviewStatusValue(data) {
            if (data == null) {
                return null;
            }
            if (data.bkExtends == null || data.bkExtends.length < 1) {
                return null;
            }
            let guaranteeReviewStatus = data.bkExtends[0].guaranteeReviewStatus;
            if (guaranteeReviewStatus == 0) {
                return this.$t('bookingSpace.other.pendingApproval');
            }
            if (guaranteeReviewStatus == 1) {
                return this.$t('bookingSpace.other.unApproved');
            }
            if (guaranteeReviewStatus == 2) {
                return this.$t('bookingSpace.other.approved');
            }
        },
        // 获取箱型和数量
        getContainerTypeAndQuantity(data) {
          if (data == null || !Array.isArray(data.bkPreContainers) || data.bkPreContainers.length === 0) {
            return null; // 或返回 '--' / '无箱型信息' 等友好提示
          }

          const parts = data.bkPreContainers
              .filter(item => item?.containerType != null && item?.quantity != null) // 过滤无效项
              .map(item => `${item.containerType} * ${item.quantity}`);

          return parts.length > 0 ? parts.join(', ') : null;
        },
        /**
         * 获取当前系统语言
         * @returns {string}
         */
        getCurLanguage() {
            return localStorage.getItem('locale');
        },
        /**
         * 根据当前语言模式获取传入元素的对应语言下的显示值
         * @param item
         * @returns {*}
         */
        getDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
        },
        /**
         * 下拉组件选项数据初始化
         */
        initCombos() {
            // 港口数据初始化
            this.portFocus();
            // 订舱状态数据初始化
            this.bookingStatusFocus();
        },
        /**
         * 处理批量操作命令
         */
        handleBatchOperation(command) {
          switch (command) {
            case 'submitSi':
              this.SumitSiInformationBtn();
              break;
            case 'batchPreview':
              this.previewBtnClick(null);
              break;
            case 'batchDownload':
              this.blDownloadBtnClick(null);
              break;
            case 'batchVgmUpload':
              this.$refs.vgmFileInput.click();
              break;
            default:
              break;
          }
        },

        // 文件选择后触发
        handleVgmFileChange(event) {
          const file = event.target.files[0];
          if (!file) return;

          // 模拟 el-upload 的 http-request 参数结构
          const uploadFile = {
            file: file,
          };

          // 调用你原来的上传逻辑
          this.batchVgmUploadBtnClick(uploadFile);

          // 清空 input，确保下次选择同一文件也能触发 change 事件
          event.target.value = '';
        },

        /**
         * 【批量VGM上传】-【EXCEL上传】按钮功能实现
         * @param param
         */
        batchVgmUploadBtnClick(param) {
          // 标记为批量上传模式（关键！）
          this.isBatchVgmUploadMode = true;
          // 清空VGM上传信息
          this.vgmContainerUploadTableData = [];

          // 校验上传文件类型
          try {
            if (!this.validateVgmFileTypeBeforeUpload(param.file)) {
              throw new Error("EndForEach");
            }
          } catch (e) {
            if (e.message !== "EndForEach") {
              this.showMessage(false, e, "error");
            } else {
              this.$message({
                message: this.$t('message.validateFileTypeFailed', {fileName: param.file.name}),
                type: 'warning'
              });
              return;
            }
          }

          let fd = new FormData();
          fd.append('file', param.file); // 传文件

          // 开启加载组件
          // 声明一个loading对象
          this.loadingtuo = this.$loading({
            lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
            text: this.$t('common.uploading'),             // 加载动画的文字
            spinner: 'el-icon-loading',                     // 引入的loading图标
            background: "rgb(0,0,0,0.1)",
          });
          let that = this;

          this.axios.post('/api/booking/bkVgmContainerDataBatchUpload', fd, {
            headers: {'Content-Type': 'multipart/form-data', 'Accept-language': localStorage.getItem("locale")},//定义内容格式,很重要
            timeout: 20000,
          }).then(response => {
            that.loadingtuo.close();

            const backCode = response.data.backCode;
            const responseMessage = response.data.backMessage;
            const responseData = response.data.object || [];

            // 无论成功失败，先保存返回的数据（用于后续展示）
            this.vgmContainerUploadTableData = responseData;

            if (backCode === "200" && Array.isArray(responseData) && responseData.length > 0) {
              // 成功：直接展示数据
              this.vgmContainerUploadShow = true;
            } else {
              // 失败：使用自定义 dialog 展示错误信息
              let errorMessage = responseMessage || this.$t('common.unknownError');
              const formattedMessage = String(errorMessage)
                  .split(';')
                  .map(s => s.trim())
                  .filter(s => s.length > 0)
                  .join('<br/>');

              // 保存错误信息并打开弹窗
              this.vgmUploadErrorMessage = formattedMessage;
              this.vgmUploadErrorDialogVisible = true;
            }
          }).catch(error => {
            if (error.data) {
              let responseCode = error.data.backMessage;
              this.showMessage(false, responseCode, "error");
            } else {
              this.showMessage(false, error, "error");
            }
            that.loadingtuo.close();
          });
        },

        /**
         * VGM 上传失败信息对话框  关闭
         */
        closeVgmErrorDialog() {
          this.vgmUploadErrorDialogVisible = false;
          // 用户点击确认后，再决定是否展示返回的数据
          const responseData = this.vgmContainerUploadTableData; // 你之前已保存
          if (Array.isArray(responseData) && responseData.length > 0) {
            this.vgmContainerUploadShow = true;
          }
        }
    },
    mounted() {
        // 页面渲染完成后初始化数据展示风格
        if (localStorage.getItem("VIEW_STYLE") != null) {
            this.showViewFlag = localStorage.getItem("VIEW_STYLE");
        } else {
            this.showViewFlag = "card";//默认展示卡片视图
        }
    },
    created() {
        this.initCombos();
        // 初始化货名及HSCODE必填航线信息
        this.initCargoDescAndHscodeRequiredRoutes();
        this.$parent.updateHeaderAside();
    },
    activated() {
        // //当提单表格有数据时需自动查询最新数据
        // if (this.tableData.length > 0) {
        //     this.searchBtnClick();
        // }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
@import "../../assets/scss/public.scss";

/*列表展示*/
.contentListCom {
  min-height: 264px;
}

.contentListCom .oneContent {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px
}

.contentListCom .top {
  height: 40px;
  border: 1px solid #E8E8E8;
  background: #E9E9E9;
  padding-left: 18px;
  line-height: 40px;
}

.contentListCom .center {
  padding: 15px 0 15px 17px;
  border: 1px solid #E8E8E8;
  background: #FFFFFF;
  border-top: none
}

.contentListCom .bottom {
  height: 40px;
  border: 1px solid #E8E8E8;
  background: #FFFFFF;
  border-top: none;
  line-height: 40px;
}

.contentListCom .listContentLong {
  width: 330px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #606266;
  margin-top: 5px;
}

.contentListCom .listContentShort {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #606266;
  margin-top: 5px;
}

.contentListCom .listContent {
  width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #606266;
  margin-top: 5px;
}

.contentListCom .listContent .thirdSpan {
  margin-left: 5px;
  display: inline-block
}

.contentListCom .center .listContent {
  font-size: 15px;
  height: 20px;
  line-height: 20px;
}

.contentListCom .center .listContent .secondSpan {
  color: #031B28;
}

.contentListCom .center .shortListContent {
  width: 220px
}

.contentListCom .center .longListContent {
  width: 320px
}

.contentListCom .listContent.rightMoney {
  text-align: right;
  margin-right: 5px
}

/*列表展示的单选和费用明细按钮*/
.contentListCom .top {
  position: relative
}

.contentListCom .top .evaluateBtn {
  margin-left: 10px;
  border-radius: 4px
}

.contentListCom .top .feeDetail {
  position: absolute;
  right: 5px;
  top: 5px
}

.contentListCom .top .checkOne {
  margin-right: 5px;
  margin-top: 5px
}

/*列表展示图标位置*/
.contentListCom .center {
  position: relative
}

.typeImg {
  width: 145px;
  height: 125px;
  position: absolute;
  right: 10px;
  top: 6px;
}

.blRefuseImg {
  background-image: url(../../assets/image/blRefuse.jpg) !important;
  background-repeat: no-repeat;
}

.blRefuseEnImg {
  background-image: url(../../assets/image/blRefuseEn.jpg) !important;
  background-repeat: no-repeat;
}

.blWaitImg {
  background-image: url(../../assets/image/blWaiting.jpg) !important;
  background-repeat: no-repeat;
}

.blWaitEnImg {
  background-image: url(../../assets/image/blWaitingEn.jpg) !important;
  background-repeat: no-repeat;
}

.blConfirmImg {
  background-image: url(../../assets/image/blConfirm.jpg) !important;
  background-repeat: no-repeat;
}

.blConfirmEnImg {
  background-image: url(../../assets/image/blConfirmEn.jpg) !important;
  background-repeat: no-repeat;
}

.blDraftImg {
  background-image: url(../../assets/image/blDraft.jpg) !important;
  background-repeat: no-repeat;
}

.blDraftEnImg {
  background-image: url(../../assets/image/blDraftEn.jpg) !important;
  background-repeat: no-repeat;
}

.flexDiv {
  display: flex;
  flex-wrap: wrap;
}

/*列表展示协议价订单等内容展示*/
.leftMessage .msg {
  line-height: 39px;
  margin-left: 10px;
  color: #606266;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.xyj {
  width: 72px;
  color: #BC1920 !important;
}

.auditMes {
  max-width: 95px;
}

.documentValid {
  width: 400px;
  margin-top: 5px;
  font-weight: bold
}

.flexDiv .normalListButton {
  margin-right: 3px;
  margin-top: 4px;
}

.flexDiv .normalListButton1 {
  margin-right: 3px;
  margin-top: 4px
}

.flexDiv .normalListBlueButton {
  margin-right: 3px;
  margin-top: 4px;
  background: $colorJ;
  color: $colorA;
  border: 1px solid #F6F6F6;
  
  &:hover {
    background: lighten($colorJ, 15%);
    transition: background 0.3s ease;
  }
}

.flexDiv .normalListRedButton {
  margin-right: 3px;
  margin-top: 4px;
  background: $colorC;
  color: $colorA;
  border: 1px solid #F6F6F6;
}

.hasBack {
  background-color: #567E8D;
  color: #fff
}

.hasBack:hover {
  background-color: #354953 !important;
  color: #fff !important;
}

/*其他常用*/
.visCom {
  visibility: hidden
}

.overflow {
  overflow: hidden
}

.l {
  float: left
}

.r {
  float: right
}

.flexDiv {
  display: flex;
  flex-wrap: wrap;
}

.inputName {
  flex: 1;
  margin: 0 5px;
}

.topMargin {
  margin-top: 20px;
}

.searchBtn {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin: 0 5px;
}

.voyageIcon {
  margin-left: 10px;
  margin-top: 5px;
  width: 30px;
  height: 30px;
  border: 1px solid #0091ff;
  border-radius: 4px;
}

.noData {
  height: 100%;
  margin: 15px 0;
  background-color: #ffffff;
}

.searchList {
  margin: 15px 0;
}

/deep/ .el-input-group__prepend {
  background-color: #d9e3f0;
}

.popoverView {
  padding: 5px;
  background-color: #ffffff;
}

.popoverInner {
  margin: 5px;
  margin-top: 0;
}

.flex1 {
  flex: 1;
}

.boatBox {
  position: relative;

  .boatBox-list-box {
    min-width: 280px;
    position: absolute;
    left: 51px;
    top: 30px;
    background: $colorA;
    padding: 5px 10px;
    z-index: 100;
    border: 1px solid $colorE;
    font-size: $fontC;
    font-weight: 600;

    .boatBox-top {
      width: 100%;
      height: 20px;
      line-height: 20px;
      background: $colorB;
    }

    .left {
      width: 30%;
      margin-right: 4%;
    }

    .right {
      width: 66%;
    }

    ul {
      padding: 0;
      margin: 0;

      li {
        border-bottom: 1px solid #e7f0fc;
        padding: 4px 2px;
      }

      li:last-of-type {
        border: none;
      }

      li:hover {
        background: rgb(224, 240, 245);
      }
    }
  }
}

/*重写按钮禁用时文字显示颜色。统一显示灰色*/
.vxe-operate-default ::v-deep.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
}

</style>
<style lang="scss">

//全选icon
.el-icon-my-selectAll {
  background: url('../../assets/image/icon/selectAll.png') center center no-repeat;
  font-size: 16px;
  background-size: cover;
}

.el-icon-my-selectAll:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}

//反选icon
.el-icon-my-selectInverse {
  background: url('../../assets/image/icon/selectInverse.png') center center no-repeat;
  font-size: 16px;
  background-size: cover;
}

.el-icon-my-selectInverse:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

/* 自定义弹窗样式 */
.format-settings-dialog .el-dialog__body {
  padding: 0;
}

/* 隐藏标题行 */
.format-settings-dialog .el-dialog__header {
  display: none;
}

/* 设置关闭按钮为白色 */
.format-settings-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}

.format-settings-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #ffffff;
}

/* 让组件内容充满整个对话框 */
.format-settings-dialog .el-dialog {
  margin: 0;
  padding: 0;
}

.format-settings-dialog .el-dialog__body {
  padding: 0;
  margin: 0;
  height: 100%;
}

/* 确保bl-format-settings组件占满整个空间 */
.format-settings-dialog .bl-format-settings {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>